export default {
    "poem_0": {
        "content": "关关雎鸠，在河之洲。窈窕淑女，君子好逑。参差荇菜，左右流之。窈窕淑女，寤寐求之。求之不得，寤寐思服。悠哉悠哉，辗转反侧。参差荇菜，左右采之。窈窕淑女，琴瑟友之。参差荇菜，左右芼之。窈窕淑女，钟鼓乐之。",
        "title": "关雎",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_1": {
        "content": "采薇采薇，薇亦作止。曰归曰归，岁亦莫止。 靡室靡家，猃狁之故。不遑启居，猃狁之故。采薇采薇，薇亦柔止。曰归曰归，心亦忧止。 忧心烈烈，载饥载渴。我戍未定，靡使归聘。采薇采薇，薇亦刚止。曰归曰归，岁亦阳止。 王事靡盬，不遑启处。忧心孔疚，我行不来！彼尔维何？维常之华。彼路斯何？君子之车。 戎车既驾，四牡业业。岂敢定居？一月三捷。驾彼四牡，四牡骙骙。君子所依，小人所腓。 四牡翼翼，象弭鱼服。岂不日戒？猃狁孔棘！昔我往矣，杨柳依依。今我来思，雨雪霏霏。 行道迟迟，载渴载饥。我心伤悲，莫知我哀！",
        "title": "采薇",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_2": {
        "content": "蒹葭苍苍，白露为霜。所谓伊人，在水一方。溯洄从之，道阻且长。溯游从之，宛在水中央。蒹葭萋萋，白露未晞。所谓伊人，在水之湄。溯洄从之，道阻且跻。溯游从之，宛在水中坻。蒹葭采采，白露未已。所谓伊人，在水之涘。溯洄从之，道阻且右。溯游从之，宛在水中沚。",
        "title": "蒹葭",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_3": {
        "content": "桃之夭夭，灼灼其华。之子于归，宜其室家。桃之夭夭，有蕡其实。之子于归，宜其家室。桃之夭夭，其叶蓁蓁。之子于归，宜其家人。",
        "title": "桃夭",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_4": {
        "content": "日出而作，日入而息。凿井而饮，耕田而食。帝力于我何有哉！",
        "title": "击壤歌",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_5": {
        "content": "投我以木瓜，报之以琼琚。匪报也，永以为好也！投我以木桃，报之以琼瑶。匪报也，永以为好也！投我以木李，报之以琼玖。匪报也，永以为好也！",
        "title": "木瓜",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_6": {
        "content": "硕鼠硕鼠，无食我黍！三岁贯女，莫我肯顾。逝将去女，适彼乐土。乐土乐土，爰得我所。硕鼠硕鼠，无食我麦！三岁贯女，莫我肯德。逝将去女，适彼乐国。乐国乐国，爰得我直。硕鼠硕鼠，无食我苗！三岁贯女，莫我肯劳。逝将去女，适彼乐郊。乐郊乐郊，谁之永号？(女 通 汝)",
        "title": "硕鼠",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_7": {
        "content": "岂曰无衣？七兮。不如子之衣，安且吉兮。岂曰无衣？六兮。不如子之衣，安且燠兮。",
        "title": "无衣",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_8": {
        "content": "力拔山兮气盖世。时不利兮骓不逝。骓不逝兮可奈何！虞兮虞兮奈若何！",
        "title": "垓下歌",
        "author": "项羽",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_9": {
        "content": "相鼠有皮，人而无仪！人而无仪，不死何为？相鼠有齿，人而无止！人而无止，不死何俟？相鼠有体，人而无礼，人而无礼！胡不遄死？",
        "title": "相鼠",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_10": {
        "content": "上邪，我欲与君相知，长命无绝衰。山无陵，江水为竭。冬雷震震，夏雨雪。天地合，乃敢与君绝。",
        "title": "上邪",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_11": {
        "content": "北方有佳人。绝世而独立。一顾倾人城。再顾倾人国。宁不知倾城与倾国。佳人难再得。",
        "title": "李延年歌",
        "author": "李延年",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_12": {
        "content": "坎坎伐檀兮，置之河之干兮。河水清且涟猗。不稼不穑，胡取禾三百廛兮？不狩不猎，胡瞻尔庭有县貆兮？彼君子兮，不素餐兮！坎坎伐辐兮，置之河之侧兮。河水清且直猗。不稼不穑，胡取禾三百亿兮？不狩不猎，胡瞻尔庭有县特兮？彼君子兮，不素食兮！坎坎伐轮兮，置之河之漘兮。河水清且沦猗。不稼不穑，胡取禾三百囷兮？不狩不猎，胡瞻尔庭有县鹑兮？彼君子兮，不素飧兮！",
        "title": "伐檀",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_13": {
        "content": "江南可采莲，莲叶何田田，鱼戏莲叶间。鱼戏莲叶东，鱼戏莲叶西，鱼戏莲叶南，鱼戏莲叶北。",
        "title": "江南",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_14": {
        "content": "秋风起兮白云飞，草木黄落兮雁南归。兰有秀兮菊有芳，怀佳人兮不能忘。泛楼船兮济汾河，横中流兮扬素波。箫鼓鸣兮发棹歌，欢乐极兮哀情多。少壮几时兮奈老何！",
        "title": "秋风辞",
        "author": "刘彻",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_15": {
        "content": "大风起兮云飞扬，威加海内兮归故乡，安得猛士兮守四方！",
        "title": "大风歌",
        "author": "刘邦",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_16": {
        "content": "谁谓河广？一苇杭之。谁谓宋远？跂予望之。谁谓河广？曾不容刀。谁谓宋远？曾不崇朝。",
        "title": "河广",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_17": {
        "content": "风萧萧兮易水寒，壮士一去兮不复还。(复还 一作：复反)探虎穴兮入蛟宫，仰天呼气兮成白虹。(此句疑为后人补作)",
        "title": "荆轲歌 / 渡易水歌",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "先秦"
    },
    "poem_18": {
        "content": "十五从军征，八十始得归。道逢乡里人：“家中有阿谁？”“遥看是君家，松柏冢累累。”(遥看 一作：遥望)兔从狗窦入，雉从梁上飞。中庭生旅谷，井上生旅葵。舂谷持作饭，采葵持作羹。羹饭一时熟，不知贻阿谁？出门东向看，泪落沾我衣。",
        "title": "十五从军征",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_19": {
        "content": "明月何皎皎，照我罗床帏。忧愁不能寐，揽衣起徘徊。客行虽云乐，不如早旋归。出户独彷徨，愁思当告谁！引领还入房，泪下沾裳衣。",
        "title": "明月何皎皎",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_20": {
        "content": "东城高且长，逶迤自相属。回风动地起，秋草萋已绿。四时更变化，岁暮一何速！晨风怀苦心，蟋蟀伤局促。荡涤放情志，何为自结束？燕赵多佳人，美者颜如玉。被服罗裳衣，当户理清曲。音响一何悲！弦急知柱促。驰情整巾带，沉吟聊踯躅。思为双飞燕，衔泥巢君屋。",
        "title": "东城高且长",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_21": {
        "content": "秋风萧萧愁杀人，出亦愁，入亦愁。座中何人，谁不怀忧。令我白头。胡地多飚风，树木何修修。离家日趋远，衣带日趋缓。心思不能言，肠中车轮转。",
        "title": "古歌",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_22": {
        "content": "行行重行行，与君生别离。相去万余里，各在天一涯。道路阻且长，会面安可知？胡马依北风，越鸟巢南枝。相去日已远，衣带日已缓。浮云蔽白日，游子不顾返。思君令人老，岁月忽已晚。弃捐勿复道，努力加餐饭。",
        "title": "行行重行行",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_23": {
        "content": "迢迢牵牛星，皎皎河汉女。纤纤擢素手，札札弄机杼。终日不成章，泣涕零如雨；河汉清且浅，相去复几许！盈盈一水间，脉脉不得语。",
        "title": "迢迢牵牛星",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_24": {
        "content": "青青园中葵，朝露待日晞。阳春布德泽，万物生光辉。常恐秋节至，焜黄华叶衰。百川东到海，何时复西归？少壮不努力，老大徒伤悲！",
        "title": "长歌行",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_25": {
        "content": "涉江采芙蓉，兰泽多芳草。采之欲遗谁，所思在远道。还顾望旧乡，长路漫浩浩。同心而离居，忧伤以终老。",
        "title": "涉江采芙蓉",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_26": {
        "content": "回车驾言迈，悠悠涉长道。四顾何茫茫，东风摇百草。所遇无故物，焉得不速老。盛衰各有时，立身苦不早。人生非金石，岂能长寿考？奄忽随物化，荣名以为宝。",
        "title": "回车驾言迈",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_27": {
        "content": "客从远方来，遗我一端绮。相去万余里，故人心尚尔。文采双鸳鸯，裁为合欢被。著以长相思，缘以结不解。以胶投漆中，谁能别离此？",
        "title": "客从远方来",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_28": {
        "content": "神龟虽寿，犹有竟时。腾蛇乘雾，终为土灰。(腾 一作：螣)老骥伏枥，志在千里。烈士暮年，壮心不已。盈缩之期，不但在天；养怡之福，可得永年。幸甚至哉，歌以咏志。",
        "title": "龟虽寿 / 神龟虽寿",
        "author": "曹操",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_29": {
        "content": "凛凛岁云暮，蝼蛄夕鸣悲。凉风率已厉，游子寒无衣。锦衾遗洛浦，同袍与我违。独宿累长夜，梦想见容辉。良人惟古欢，枉驾惠前绥。愿得常巧笑，携手同车归。既来不须臾，又不处重闱。亮无晨风翼，焉能凌风飞？眄睐以适意，引领遥相睎。徙倚怀感伤，垂涕沾双扉。",
        "title": "凛凛岁云暮",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_30": {
        "content": "关东有义士，兴兵讨群凶。初期会盟津，乃心在咸阳。军合力不齐，踌躇而雁行。势利使人争，嗣还自相戕。淮南弟称号，刻玺於北方。铠甲生虮虱，万姓以死亡。白骨露於野，千里无鸡鸣。生民百遗一，念之断人肠。",
        "title": "蒿里行",
        "author": "曹操",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_31": {
        "content": "东临碣石，以观沧海。水何澹澹，山岛竦峙。树木丛生，百草丰茂。秋风萧瑟，洪波涌起。日月之行，若出其中；星汉灿烂，若出其里。幸甚至哉，歌以咏志。",
        "title": "步出夏门行·观沧海",
        "author": "曹操",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_32": {
        "content": "对酒当歌，人生几何！譬如朝露，去日苦多。慨当以慷，忧思难忘。何以解忧？唯有杜康。青青子衿，悠悠我心。但为君故，沉吟至今。呦呦鹿鸣，食野之苹。我有嘉宾，鼓瑟吹笙。明明如月，何时可掇？忧从中来，不可断绝。越陌度阡，枉用相存。契阔谈讌，心念旧恩。(谈讌 一作：谈宴)月明星稀，乌鹊南飞。绕树三匝，何枝可依？山不厌高，海不厌深。周公吐哺，天下归心。(海 一作：水)",
        "title": "短歌行",
        "author": "曹操",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_33": {
        "content": "亭亭山上松，瑟瑟谷中风。风声一何盛，松枝一何劲。冰霜正惨凄，终岁常端正。岂不罹凝寒，松柏有本性。",
        "title": "赠从弟",
        "author": "刘桢",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_34": {
        "content": "举秀才，不知书。举孝廉，父别居。寒素清白浊如泥，高第良将怯如鸡。",
        "title": "桓灵时童谣",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_35": {
        "content": "煮豆燃豆萁，豆在釜中泣。本是同根生，相煎何太急？（版本一）煮豆持作羹，漉菽以为汁。萁在釜下燃，豆在釜中泣。本自同根生，相煎何太急？（版本二）",
        "title": "七步诗",
        "author": "曹植",
        "book": "古诗三百首",
        "dynasty": "两汉"
    },
    "poem_36": {
        "content": "秋风萧瑟天气凉，草木摇落露为霜，群燕辞归鹄南翔。(鹄南翔 一作 雁南翔）念君客游思断肠，慊慊思归恋故乡，君何淹留寄他方？贱妾茕茕守空房，忧来思君不敢忘，不觉泪下沾衣裳。援琴鸣弦发清商，短歌微吟不能长。明月皎皎照我床，星汉西流夜未央。牵牛织女遥相望，尔独何辜限河梁。",
        "title": "燕歌行二首·其一",
        "author": "曹丕",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_37": {
        "content": "夜中不能寐，起坐弹鸣琴。薄帷鉴明月，清风吹我襟。孤鸿号外野，翔鸟鸣北林。徘徊将何见？忧思独伤心。",
        "title": "咏怀八十二首·其一",
        "author": "阮籍",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_38": {
        "content": "白马饰金羁，连翩西北驰。借问谁家子，幽并游侠儿。 少小去乡邑，扬声沙漠垂。宿昔秉良弓，楛矢何参差。控弦破左的，右发摧月支。仰手接飞猱，俯身散马蹄。狡捷过猴猿，勇剽若豹螭。边城多警急，虏骑数迁移。羽檄从北来，厉马登高堤。长驱蹈匈奴，左顾凌鲜卑。弃身锋刃端，性命安可怀？父母且不顾，何言子与妻！名编壮士籍，不得中顾私。捐躯赴国难，视死忽如归！(名编 一作：名在) ",
        "title": "白马篇",
        "author": "曹植",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_39": {
        "content": "西京乱无象，豺虎方遘患。复弃中国去，委身适荆蛮。亲戚对我悲，朋友相追攀。出门无所见，白骨蔽平原。路有饥妇人，抱子弃草间。顾闻号泣声，挥涕独不还。“未知身死处，何能两相完？”驱马弃之去，不忍听此言。南登霸陵岸，回首望长安，悟彼下泉人，喟然伤心肝。",
        "title": "七哀诗三首·其一",
        "author": "王粲",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_40": {
        "content": "沉阴结愁忧，愁忧为谁兴？念与君相别，各在天一方。良会未有期，中心摧且伤。不聊忧餐食，慊慊常饥空。端坐而无为，仿佛君容光。峨峨高山首，悠悠万里道。君去日已远，郁结令人老。人生一世间，忽若暮春草。时不可再得，何为自愁恼？每诵昔鸿恩，贱躯焉足保。浮云何洋洋，愿因通我词。飘摇不可寄，徙倚徒相思。人离皆复会，君独无返期。自君之出矣，明镜暗不治。思君如流水，何有穷已时。惨惨时节尽，兰叶复凋零。喟然长叹息，君期慰我情。辗转不能寐，长夜何绵绵。蹑履起出户，仰观三星连。自恨志不遂，泣涕如涌泉。思君见巾栉，以益我劳勤。安得鸿鸾羽，觏此心中人。诚心亮不遂，搔首立悁悁。何言一不见，复会无因缘。故如比目鱼，今隔如参辰。人靡不有初，想君能终之。别来历年岁，旧恩何可期。重新而忘故，君子所尤讥。寄身虽在远，岂忘君须臾。既厚不为薄，想君时见思。",
        "title": "室思",
        "author": "徐干",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_41": {
        "content": "宁饮建业水，不食武昌鱼。宁还建业死，不止武昌居。",
        "title": "吴孙皓初童谣",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_42": {
        "content": "息徒兰圃，秣马华山。流磻平皋，垂纶长川。目送归鸿，手挥五弦。俯仰自得，游心太玄。嘉彼钓翁，得鱼忘筌。郢人逝矣，谁与尽言？",
        "title": "赠秀才入军·其十四",
        "author": "嵇康",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_43": {
        "content": "南国有佳人，容华若桃李。朝游江北岸，夕宿潇湘沚。时俗薄朱颜，谁为发皓齿？俯仰岁将暮，荣耀难久恃。",
        "title": "杂诗七首·其四",
        "author": "曹植",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_44": {
        "content": "结庐在人境，而无车马喧。问君何能尔？心远地自偏。采菊东篱下，悠然见南山。山气日夕佳，飞鸟相与还。此中有真意，欲辨已忘言。(辨 通：辩)",
        "title": "饮酒·其五",
        "author": "陶渊明",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_45": {
        "content": "郁郁涧底松，离离山上苗。以彼径寸茎，荫此百尺条。世胄蹑高位，英俊沉下僚。地势使之然，由来非一朝。金张藉旧业，七叶珥汉貂。冯公岂不伟，白首不见招。",
        "title": "咏史·郁郁涧底松",
        "author": "左思",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_46": {
        "content": "少无适俗韵，性本爱丘山。误落尘网中，一去三十年。(误落 一作：误入)羁鸟恋旧林，池鱼思故渊。开荒南野际，守拙归园田。方宅十余亩，草屋八九间。榆柳荫后檐，桃李罗堂前。暧暧远人村，依依墟里烟。狗吠深巷中，鸡鸣桑树颠。(颠 通 巅)户庭无尘杂，虚室有余闲。久在樊笼里，复得返自然。",
        "title": "归园田居·其一",
        "author": "陶渊明",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_47": {
        "content": "种豆南山下，草盛豆苗稀。晨兴理荒秽，带月荷锄归。道狭草木长，夕露沾我衣。衣沾不足惜，但使愿无违。",
        "title": "归园田居·其三",
        "author": "陶渊明",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_48": {
        "content": "燕丹善养士，志在报强嬴。招集百夫良，岁暮得荆卿。君子死知己，提剑出燕京；素骥鸣广陌，慷慨送我行。雄发指危冠，猛气冲长缨。饮饯易水上，四座列群英。渐离击悲筑，宋意唱高声。萧萧哀风逝，淡淡寒波生。商音更流涕，羽奏壮士惊。心知去不归，且有后世名。登车何时顾，飞盖入秦庭。凌厉越万里，逶迤过千城。图穷事自至，豪主正怔营。惜哉剑术疏，奇功遂不成。其人虽已没，千载有馀情。",
        "title": "咏荆轲",
        "author": "陶渊明",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_49": {
        "content": "精卫衔微木，将以填沧海。刑天舞干戚，猛志固常在。同物既无虑，化去不复悔。徒设在昔心，良辰讵可待。",
        "title": "读山海经·其十",
        "author": "陶渊明",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_50": {
        "content": "江南倦历览，江北旷周旋。怀新道转迥，寻异景不延。乱流趋正绝，孤屿媚中川。云日相晖映，空水共澄鲜。表灵物莫赏，蕴真谁为传。想象昆山姿，缅邈区中缘。始信安期术，得尽养生年。",
        "title": "登江中孤屿",
        "author": "谢灵运",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_51": {
        "content": "人生无根蒂，飘如陌上尘。分散逐风转，此已非常身。落地为兄弟，何必骨肉亲！得欢当作乐，斗酒聚比邻。盛年不重来，一日难再晨。及时当勉励，岁月不待人。",
        "title": "杂诗",
        "author": "陶渊明",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_52": {
        "content": "中庭多杂树，偏为梅咨嗟。问君何独然？念其霜中能作花，露中能作实。摇荡春风媚春日，念尔零落逐风飚，徒有霜华无霜质。",
        "title": "梅花落",
        "author": "鲍照",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_53": {
        "content": "对案不能食，拔剑击柱长叹息。丈夫生世会几时？安能蹀躞垂羽翼！弃置罢官去，还家自休息。朝出与亲辞，暮还在亲侧。弄儿床前戏，看妇机中织。自古圣贤尽贫贱，何况我辈孤且直！",
        "title": "拟行路难·其六",
        "author": "鲍照",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_54": {
        "content": "折花逢驿使，寄与陇头人。(折花 一作：折梅)江南无所有，聊赠一枝春。",
        "title": "赠范晔诗",
        "author": "陆凯",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_55": {
        "content": "灞涘望长安，河阳视京县。白日丽飞甍，参差皆可见。余霞散成绮，澄江静如练。喧鸟覆春洲，杂英满芳甸。去矣方滞淫，怀哉罢欢宴。佳期怅何许，泪下如流霰。有情知望乡，谁能鬒不变？",
        "title": "晚登三山还望京邑",
        "author": "谢朓",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_56": {
        "content": "绿草蔓如丝，杂树红英发。无论君不归，君归芳已歇。",
        "title": "王孙游",
        "author": "谢朓",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_57": {
        "content": "泻水置平地，各自东西南北流。人生亦有命，安能行叹复坐愁？酌酒以自宽，举杯断绝歌路难。心非木石岂无感？吞声踯躅不敢言。",
        "title": "拟行路难·其四",
        "author": "鲍照",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_58": {
        "content": "秋风起兮木叶飞，吴江水兮鲈正肥。三千里兮家未归，恨难禁兮仰天悲。",
        "title": "思吴江歌",
        "author": "张翰",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_59": {
        "content": "江干远树浮，天末孤烟起。江天自如合，烟树还相似。沧流未可源，高帆去何已。",
        "title": "之零陵郡次新亭",
        "author": "范云",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_60": {
        "content": "兔园标物序，惊时最是梅。衔霜当路发，映雪拟寒开。枝横却月观，花绕凌风台。朝洒长门泣，夕驻临邛杯。应知早飘落，故逐上春来。",
        "title": "咏早梅 / 扬州法曹梅花盛开",
        "author": "何逊",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_61": {
        "content": "孟夏草木长，绕屋树扶疏。 众鸟欣有托，吾亦爱吾庐。 既耕亦已种，时还读我书。 穷巷隔深辙，颇回故人车。 欢言酌春酒，摘我园中蔬。 微雨从东来，好风与之俱。 泛览《周王传》，流观《山海》图。 俯仰终宇宙，不乐复何如？ ",
        "title": "读山海经·其一",
        "author": "陶渊明",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_62": {
        "content": "河汉纵且横，北斗横复直。星汉空如此，宁知心有忆？孤灯暧不明，寒机晓犹织。零泪向谁道，鸡鸣徒叹息。",
        "title": "夜夜曲",
        "author": "沈约",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_63": {
        "content": "古人云此水，一歃怀千金。试使夷齐饮，终当不易心。",
        "title": "酌贪泉",
        "author": "吴隐之",
        "book": "古诗三百首",
        "dynasty": "魏晋"
    },
    "poem_64": {
        "content": "郎作十里行，侬作九里送。拔侬头上钗，与郎资路用。有信数寄书，无信心相忆。莫作瓶落井，一去无消息。大艑珂峨头，何处发扬州。借问艑上郎，见侬所欢不？初发扬州时，船出平津泊。五两如竹林，何处相寻博。",
        "title": "估客乐四首",
        "author": "释宝月",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_65": {
        "content": "柳黄未吐叶，水绿半含苔。春色边城动，客思故乡来。",
        "title": "边城思",
        "author": "何逊",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_66": {
        "content": "山际见来烟，竹中窥落日。鸟向檐上飞，云从窗里出。",
        "title": "山中杂诗",
        "author": "吴均",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_67": {
        "content": "山中何所有，岭上多白云。只可自怡悦，不堪持赠君。",
        "title": "诏问山中何所有赋诗以答",
        "author": "陶弘景",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_68": {
        "content": "艅艎何泛泛，空水共悠悠。阴霞生远岫，阳景逐回流。蝉噪林逾静，鸟鸣山更幽。此地动归念，长年悲倦游。",
        "title": "入若耶溪",
        "author": "王籍",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_69": {
        "content": "建平督邮道，鱼复永安宫。若奏巴渝曲，时当君思中。",
        "title": "蜀道难·其一",
        "author": "萧纲",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_70": {
        "content": "大江一浩荡，离悲足几重。潮落犹如盖，云昏不作峰。远戍唯闻鼓，寒山但见松。九十方称半，归途讵有踪。",
        "title": "晚出新亭",
        "author": "阴铿",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_71": {
        "content": "春蚕不应老，昼夜常怀丝。何惜微躯尽，缠绵自有时。",
        "title": "作蚕丝",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_72": {
        "content": "玉关道路远，金陵信使疏。独下千行泪，开君万里书。",
        "title": "寄王琳",
        "author": "庾信",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_73": {
        "content": "上马不捉鞭，反折杨柳枝。蹀座吹长笛，愁杀行客儿。腹中愁不乐，愿作郎马鞭。出入擐郎臂，蹀座郎膝边。放马两泉泽，忘不著连羁。担鞍逐马走，何见得马骑。遥看孟津河，杨柳郁婆娑。我是虏家儿，不解汉儿歌。健儿须快马，快马须健儿。跸跋黄尘下，然后别雄雌。 ",
        "title": "折杨柳歌辞五首",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_74": {
        "content": "关山三五月，客子忆秦川。思妇高楼上，当窗应未眠。星旗映疏勒，云阵上祁连。战气今如此，从军复几年。",
        "title": "关山月",
        "author": "徐陵",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_75": {
        "content": "巫山七百里，巴水三回曲。笛声下复高，猿啼断还续。",
        "title": "蜀道难·其二",
        "author": "萧纲",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_76": {
        "content": "敕勒川，阴山下。天似穹庐，笼盖四野。天苍苍，野茫茫。风吹草低见牛羊。",
        "title": "敕勒歌",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_77": {
        "content": "心逐南云逝，形随北雁来。故乡篱下菊，今日几花开。",
        "title": "于长安归还扬州九月九日行薇山亭赋韵 / 长安九日诗",
        "author": "江总",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_78": {
        "content": "陇头流水，流离山下。念吾一身，飘然旷野。朝发欣城，暮宿陇头。寒不能语，舌卷入喉。陇头流水，鸣声呜咽。遥望秦川，心肝断绝。 ",
        "title": "陇头歌辞三首",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_79": {
        "content": "入春才七日，离家已二年。人归落雁后，思发在花前。",
        "title": "人日思归",
        "author": "薛道衡",
        "book": "古诗三百首",
        "dynasty": "隋代"
    },
    "poem_80": {
        "content": "可惜庭中树，移根逐汉臣。只为来时晚，花开不及春。",
        "title": "侍宴咏石榴",
        "author": "孔绍安",
        "book": "古诗三百首",
        "dynasty": "唐代"
    },
    "poem_81": {
        "content": "亭亭画舸系春潭，直到行人酒半酣。不管烟波与风雨，载将离恨过江南。",
        "title": "柳枝词",
        "author": "郑文宝",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_82": {
        "content": "马穿山径菊初黄，信马悠悠野兴长。万壑有声含晚籁，数峰无语立斜阳。棠梨叶落胭脂色，荞麦花开白雪香。何事吟余忽惆怅，村桥原树似吾乡。",
        "title": "村行",
        "author": "王禹偁",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_83": {
        "content": "晓带轻烟间杏花，晚凝深翠拂平沙。长条别有风流处，密映钱塘苏小家。",
        "title": "柳",
        "author": "寇准",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_84": {
        "content": "鸣骹直上一千尺，天静无风声更干。碧眼胡儿三百骑，尽提金勒向云看。",
        "title": "塞上",
        "author": "柳开",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_85": {
        "content": "两株桃杏映篱斜，妆点商州副使家。何事春风容不得？和莺吹折数枝花。",
        "title": "春居杂兴·两株桃杏映篱斜",
        "author": "王禹偁",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_86": {
        "content": "岸阔樯稀波渺茫，独凭危槛思何长。萧萧远树疏林外，一半秋山带夕阳。",
        "title": "书河上亭壁",
        "author": "寇准",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_87": {
        "content": "白云满鄣来，黄尘暗天起。关山四面绝，故乡几千里。",
        "title": "断句",
        "author": "刘昶",
        "book": "古诗三百首",
        "dynasty": "南北朝"
    },
    "poem_88": {
        "content": "众芳摇落独暄妍，占尽风情向小园。疏影横斜水清浅，暗香浮动月黄昏。霜禽欲下先偷眼，粉蝶如知合断魂。幸有微吟可相狎，不须檀板共金尊。(金尊 通：樽)",
        "title": "山园小梅·其一",
        "author": "林逋",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_89": {
        "content": "坠素翻红各自伤，青楼烟雨忍相忘。将飞更作回风舞，已落犹成半面妆。沧海客归珠有泪，章台人去骨遗香。可能无意传双蝶，尽付芳心与蜜房。",
        "title": "落花",
        "author": "宋祁",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_90": {
        "content": "枕中云气千峰近，床底松声万壑哀。要看银山拍天浪，开窗放入大江来。",
        "title": "宿甘露寺僧舍",
        "author": "曾公亮",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_91": {
        "content": "鲍老当筵笑郭郎，笑他舞袖太郎当。若教鲍老当筵舞，转更郎当舞袖长。",
        "title": "咏傀儡",
        "author": "杨亿",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_92": {
        "content": "适与野情惬，千山高复低。好峰随处改，幽径独行迷。霜落熊升树，林空鹿饮溪。人家在何许？云外一声鸡。",
        "title": "鲁山山行",
        "author": "梅尧臣",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_93": {
        "content": "行到东溪看水时，坐临孤屿发船迟。野凫眠岸有闲意，老树着花无丑枝。短短蒲耳齐似剪，平平沙石净于筛。情虽不厌住不得，薄暮归来车马疲。",
        "title": "东溪",
        "author": "梅尧臣",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_94": {
        "content": "陶尽门前土，屋上无片瓦。十指不沾泥，鳞鳞居大厦。",
        "title": "陶者",
        "author": "梅尧臣",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_95": {
        "content": "红树青山日欲斜，长郊草色绿无涯。游人不管春将老，来往亭前踏落花。",
        "title": "丰乐亭游春·其三",
        "author": "欧阳修",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_96": {
        "content": "卧闻岳阳城里钟，系舟岳阳城下树。正见空江明月来，云水苍茫失江路。夜深江月弄清辉，水上人歌月下归；一阕声长听不尽，轻舟短楫去如飞。",
        "title": "晚泊岳阳",
        "author": "欧阳修",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_97": {
        "content": "夜雨连明春水生，娇云浓暖弄阴晴。帘虚日薄花竹静，时有乳鸠相对鸣。",
        "title": "初晴游沧浪亭",
        "author": "苏舜钦",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_98": {
        "content": "别院深深夏席清，石榴开遍透帘明。(夏席清 一作：夏簟清)树阴满地日当午，梦觉流莺时一声。",
        "title": "夏意",
        "author": "苏舜钦",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_99": {
        "content": "百啭千声随意移，山花红紫树高低。始知锁向金笼听，不及林间自在啼。",
        "title": "画眉鸟",
        "author": "欧阳修",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_100": {
        "content": "昨日入城市，归来泪满巾。遍身罗绮者，不是养蚕人。",
        "title": "蚕妇",
        "author": "张俞",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_101": {
        "content": "春风疑不到天涯，二月山城未见花。残雪压枝犹有桔，冻雷惊笋欲抽芽。夜闻归雁生乡思，病入新年感物华。曾是洛阳花下客，野芳虽晚不须嗟。",
        "title": "戏答元珍",
        "author": "欧阳修",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_102": {
        "content": "春云浓淡日微光，双阙重门耸建章。不上楼来知几日，满城无算柳梢黄。",
        "title": "考试毕登铨楼",
        "author": "梅尧臣",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_103": {
        "content": "爆竹声中一岁除，春风送暖入屠苏。千门万户曈曈日，总把新桃换旧符。",
        "title": "元日",
        "author": "王安石",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_104": {
        "content": "飞来山上千寻塔，闻说鸡鸣见日升。(飞来山 一作：飞来峰)不畏浮云遮望眼，只缘身在最高层。(只缘 一作：自缘)",
        "title": "登飞来峰",
        "author": "王安石",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_105": {
        "content": "墙角数枝梅，凌寒独自开。遥知不是雪，为有暗香来。",
        "title": "梅花 / 梅",
        "author": "王安石",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_106": {
        "content": "京口瓜洲一水间，钟山只隔数重山。春风又绿江南岸，明月何时照我还？",
        "title": "泊船瓜洲",
        "author": "王安石",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_107": {
        "content": "金炉香烬漏声残，剪剪轻风阵阵寒。春色恼人眠不得，月移花影上栏杆。",
        "title": "春夜",
        "author": "王安石",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_108": {
        "content": "花光浓烂柳轻明，酌酒花前送我行。我亦且如常日醉，莫教弦管作离声。",
        "title": "别滁",
        "author": "欧阳修",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_109": {
        "content": "人言落日是天涯，望极天涯不见家。已恨碧山相阻隔，碧山还被暮云遮。",
        "title": "乡思",
        "author": "李觏",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_110": {
        "content": "百战疲劳壮士哀，中原一败势难回。江东子弟今虽在，肯与君王卷土来？",
        "title": "叠题乌江亭",
        "author": "王安石",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_111": {
        "content": "云淡风轻近午天，傍花随柳过前川。时人不识余心乐，将谓偷闲学少年。",
        "title": "春日偶成",
        "author": "程颢",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_112": {
        "content": "水绕陂田竹绕篱，榆钱落尽槿花稀。夕阳牛背无人卧，带得寒鸦两两归。",
        "title": "村居",
        "author": "张舜民",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_113": {
        "content": "乱条犹未变初黄，倚得东风势便狂。解把飞花蒙日月，不知天地有清霜。",
        "title": "咏柳",
        "author": "曾巩",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_114": {
        "content": "一雨池塘水面平，淡磨明镜照檐楹。东风忽起垂杨舞，更作荷心万点声。",
        "title": "雨后池上",
        "author": "刘攽",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_115": {
        "content": "雨过横塘水满堤，乱山高下路东西。一番桃李花开尽，惟有青青草色齐。",
        "title": "城南",
        "author": "曾巩",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_116": {
        "content": "清风无力屠得热，落日着翅飞上山。人固已惧江海竭，天岂不惜河汉干？昆仑之高有积雪，蓬莱之远常遗寒。不能手提天下往，何忍身去游其间？",
        "title": "暑旱苦热",
        "author": "王令",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_117": {
        "content": "青苔满地初晴后，绿树无人昼梦余。唯有南风旧相识，偷开门户又翻书。",
        "title": "新晴",
        "author": "刘攽",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_118": {
        "content": "三月残花落更开，小檐日日燕飞来。子规夜半犹啼血，不信东风唤不回。",
        "title": "送春",
        "author": "王令",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_119": {
        "content": "竹外桃花三两枝，春江水暖鸭先知。蒌蒿满地芦芽短，正是河豚欲上时。两两归鸿欲破群，依依还似北归人。遥知朔漠多风雪，更待江南半月春。",
        "title": "惠崇春江晚景二首 / 惠崇春江晓景二首",
        "author": "苏轼",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_120": {
        "content": "人生到处知何似，应似飞鸿踏雪泥。泥上偶然留指爪，鸿飞那复计东西。老僧已死成新塔，坏壁无由见旧题。往日崎岖还记否，路长人困蹇驴嘶。",
        "title": "和子由渑池怀旧",
        "author": "苏轼",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_121": {
        "content": "春宵一刻值千金，花有清香月有阴。歌管楼台声细细，秋千院落夜沉沉。",
        "title": "春宵",
        "author": "苏轼",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_122": {
        "content": "水光潋滟晴方好，山色空蒙雨亦奇。(蒙 通：濛)欲把西湖比西子，淡妆浓抹总相宜。(淡妆浓抹 一作：浓妆淡抹)",
        "title": "饮湖上初晴后雨二首·其二",
        "author": "苏轼",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_123": {
        "content": "横看成岭侧成峰，远近高低各不同。不识庐山真面目，只缘身在此山中。",
        "title": "题西林壁",
        "author": "苏轼",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_124": {
        "content": "荷尽已无擎雨盖，菊残犹有傲霜枝。一年好景君须记，最是橙黄橘绿时。(最是 一作：正是) ",
        "title": "赠刘景文 / 冬景",
        "author": "苏轼",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_125": {
        "content": "东风袅袅泛崇光，香雾空蒙月转廊。只恐夜深花睡去，故烧高烛照红妆。",
        "title": "海棠",
        "author": "苏轼",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_126": {
        "content": "百里西风禾黍香，鸣泉落窦谷登场。老牛粗了耕耘债，啮草坡头卧夕阳。",
        "title": "禾熟",
        "author": "孔平仲",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_127": {
        "content": "试说途中景，方知别后心。行人日暮少，风雪乱山深。",
        "title": "寄内",
        "author": "孔平仲",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_128": {
        "content": "骑牛远远过前村，短笛横吹隔陇闻。多少长安名利客，机关用尽不如君。",
        "title": "牧童诗",
        "author": "黄庭坚",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_129": {
        "content": "投荒万死鬓毛斑，生出瞿塘滟滪关。未到江南先一笑，岳阳楼上对君山。满川风雨独凭栏，绾结湘娥十二鬟。可惜不当湖水面，银山堆里看青山。 ",
        "title": "雨中登岳阳楼望君山",
        "author": "黄庭坚",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_130": {
        "content": "庭户无人秋月明，夜霜欲落气先清。梧桐真不甘衰谢，数叶迎风尚有声。",
        "title": "夜坐",
        "author": "张耒",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_131": {
        "content": "风蒲猎猎弄清柔，欲立蜻蜓不自由。五月临平山下路，藕花无数满汀州。",
        "title": "临平道中",
        "author": "道潜",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_132": {
        "content": "如丝苣甲饤春盘，韭叶金黄雪未干。旅饭二年无此味，故园千里几时还。异方时节三巵酒，残岁风烟一惨颜。曾奉龙旗典邦礼，岁穷祠祀少休闲。",
        "title": "春日",
        "author": "张耒",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_133": {
        "content": "携扙来追柳外凉，画桥南畔倚胡床。月明船笛参差起，风定池莲自在香。",
        "title": "纳凉",
        "author": "秦观",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_134": {
        "content": "一夕轻雷落万丝，霁光浮瓦碧参差。有情芍药含春泪，无力蔷薇卧晓枝。",
        "title": "春日",
        "author": "秦观",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_135": {
        "content": "阴阴溪曲绿交加，小雨翻萍上浅沙。鹅鸭不知春去尽，争随流水趁桃花。",
        "title": "春日",
        "author": "晁冲之",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_136": {
        "content": "天寒水鸟自相依，十百为群戏落晖。过尽行人都不起，忽闻水响一齐飞。",
        "title": "还自广陵",
        "author": "秦观",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_137": {
        "content": "断墙着雨蜗成字，老屋无僧燕作家，剩欲出门追语笑，却嫌归鬓著尘沙。风翻蛛网开三面，雷动蜂窠趁两衙。屡失南邻春事约，只今容有未开花。",
        "title": "春怀示邻里",
        "author": "陈师道",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_138": {
        "content": "痴儿了却公家事，快阁东西倚晚晴。落木千山天远大，澄江一道月分明。朱弦已为佳人绝，青眼聊因美酒横。万里归船弄长笛，此心吾与白鸥盟。",
        "title": "登快阁",
        "author": "黄庭坚",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_139": {
        "content": "连理枝头花正开，妒花风雨便相催。愿教青帝常为主，莫遣纷纷点翠苔。",
        "title": "落花",
        "author": "朱淑真",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_140": {
        "content": "四顾山光接水光，凭栏十里芰荷香。清风明月无人管，并作南楼一味凉。",
        "title": "鄂州南楼书事",
        "author": "黄庭坚",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_141": {
        "content": "女子弄文诚可罪，那堪咏月更吟风。磨穿铁砚非吾事，绣折金针却有功。闷无消遣只看诗，不见诗中话别离。添得情怀转萧索，始知伶俐不如痴。 ",
        "title": "自责二首",
        "author": "朱淑真",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_142": {
        "content": "一春略无十日晴，处处浮云将雨行。野田春水碧于镜，人影渡傍鸥不惊。桃花嫣然出篱笑，似开未开最有情。茅茨烟暝客衣湿，破梦午鸡啼一声。",
        "title": "春日",
        "author": "汪藻",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_143": {
        "content": "游子春衫已试单，桃花飞尽野梅酸。怪来一夜蛙声歇，又作东风十日寒。",
        "title": "绝句",
        "author": "吴涛",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_144": {
        "content": "去远即相忘，归近不可忍。儿女已在眼，眉目略不省。喜极不得语，泪尽方一哂。了知不是梦，忽忽心未稳。",
        "title": "示三子",
        "author": "陈师道",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_145": {
        "content": "生当作人杰，死亦为鬼雄。至今思项羽，不肯过江东。",
        "title": "夏日绝句",
        "author": "李清照",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_146": {
        "content": "辇毂繁华事可伤，师师垂老过湖湘。缕衣檀板无颜色，一曲当时动帝王。",
        "title": "汴京纪事",
        "author": "刘子翚",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_147": {
        "content": "稍离烟瘴近湘潭，疾病衰颓已不堪。儿女不知来避地，强言风物胜江南。",
        "title": "连州阳山归路",
        "author": "吕本中",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_148": {
        "content": "双飞燕子几时回？夹岸桃花蘸水开。春雨断桥人不度，小舟撑出柳阴来。",
        "title": "春游湖",
        "author": "徐俯",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_149": {
        "content": "苏秀道中，自七月二十五日夜大雨三日，秋苗以苏，喜而有作。一夕骄阳转作霖，梦回凉冷润衣襟。不愁屋漏床床湿，且喜溪流岸岸深。千里稻花应秀色，五更桐叶最佳音。无田似我犹欣舞，何况田间望岁心。",
        "title": "苏秀道中",
        "author": "曾几",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_150": {
        "content": "梅子黄时日日晴，小溪泛尽却山行。绿阴不减来时路，添得黄鹂四五声。",
        "title": "三衢道中",
        "author": "曾几",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_151": {
        "content": "飞花两岸照船红，百里榆堤半日风。卧看满天云不动，不知云与我俱东。",
        "title": "襄邑道中",
        "author": "陈与义",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_152": {
        "content": "一自胡尘入汉关，十年伊洛路漫漫。青墩溪畔龙钟客，独立东风看牡丹。",
        "title": "咏牡丹",
        "author": "陈与义",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_153": {
        "content": "经年尘土满征衣，特特寻芳上翠微。好水好山看不足，马蹄催趁月明归。",
        "title": "池州翠微亭",
        "author": "岳飞",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_154": {
        "content": "世味年来薄似纱，谁令骑马客京华。小楼一夜听春雨，深巷明朝卖杏花。矮纸斜行闲作草，晴窗细乳戏分茶。素衣莫起风尘叹，犹及清明可到家。",
        "title": "临安春雨初霁",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_155": {
        "content": "一担乾柴古渡头，盘缠一日颇优游。归来涧底磨刀斧，又作全家明日谋。",
        "title": "樵夫",
        "author": "萧德藻",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_156": {
        "content": "黄金错刀白玉装，夜穿窗扉出光芒。丈夫五十功未立，提刀独立顾八荒。京华结交尽奇士，意气相期共生死。千年史册耻无名，一片丹心报天子。尔来从军天汉滨，南山晓雪玉嶙峋。呜呼！楚虽三户能亡秦，岂有堂堂中国空无人！",
        "title": "金错刀行",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_157": {
        "content": "天缺西南江面清，纤云不动小滩横。墙头语鹊衣犹湿，楼外残雷气未平。尽取微凉供稳睡，急搜奇句报新晴。今宵绝胜无人共，卧看星河尽意明。",
        "title": "雨晴",
        "author": "陈与义",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_158": {
        "content": "耕犁千亩实千箱，力尽筋疲谁复伤？但得众生皆得饱，不辞羸病卧残阳。",
        "title": "病牛",
        "author": "李纲",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_159": {
        "content": "衣上征尘杂酒痕，远游无处不消魂。此身合是诗人未？细雨骑驴入剑门。",
        "title": "剑门道中遇微雨",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_160": {
        "content": "闻道梅花坼晓风，雪堆遍满四山中。何方可化身千亿，一树梅花一放翁。",
        "title": "梅花绝句·其一",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_161": {
        "content": "死去元知万事空，但悲不见九州同。王师北定中原日，家祭无忘告乃翁。",
        "title": "示儿",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_162": {
        "content": "风卷江湖雨暗村，四山声作海涛翻。溪柴火软蛮毡暖，我与狸奴不出门。僵卧孤村不自哀，尚思为国戍轮台。夜阑卧听风吹雨，铁马冰河入梦来。",
        "title": "十一月四日风雨大作二首",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_163": {
        "content": "早岁那知世事艰，中原北望气如山。楼船夜雪瓜洲渡，铁马秋风大散关。塞上长城空自许，镜中衰鬓已先斑。出师一表真名世，千载谁堪伯仲间！",
        "title": "书愤五首·其一",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_164": {
        "content": "病骨支离纱帽宽，孤臣万里客江干。位卑未敢忘忧国，事定犹须待阖棺。天地神灵扶庙社，京华父老望和銮。出师一表通今古，夜半挑灯更细看。",
        "title": "病起书怀",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_165": {
        "content": "迢迢天汉西南落，喔喔邻鸡一再鸣。壮志病来消欲尽，出门搔首怆平生。三万里河东入海，五千仞岳上摩天。遗民泪尽胡尘里，南望王师又一年。",
        "title": "秋夜将晓出篱门迎凉有感二首",
        "author": "陆游",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_166": {
        "content": "泉眼无声惜细流，树阴照水爱晴柔。小荷才露尖尖角，早有蜻蜓立上头。",
        "title": "小池",
        "author": "杨万里",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_167": {
        "content": "毕竟西湖六月中，风光不与四时同。接天莲叶无穷碧，映日荷花别样红。",
        "title": "晓出净慈寺送林子方",
        "author": "杨万里",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_168": {
        "content": "州桥南北是天街，父老年年等驾回。忍泪失声询使者，\"几时真有六军来？\" ",
        "title": "州桥",
        "author": "范成大",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_169": {
        "content": "昼出耘田夜绩麻，村庄儿女各当家。童孙未解供耕织，也傍桑阴学种瓜。",
        "title": "夏日田园杂兴·其七",
        "author": "范成大",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_170": {
        "content": "溪水将桥不复回，小舟犹倚短篙开。交情得似山溪渡，不管风波去又来。",
        "title": "三江小渡",
        "author": "杨万里",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_171": {
        "content": "一叶渔船两小童，收篙停棹坐船中。怪生无雨都张伞，不是遮头是使风。",
        "title": "舟过安仁",
        "author": "杨万里",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_172": {
        "content": "篱落疏疏一径深，树头花落未成阴。儿童急走追黄蝶，飞入菜花无处寻。",
        "title": "宿新市徐公店",
        "author": "杨万里",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_173": {
        "content": "山外青山楼外楼，西湖歌舞几时休？暖风熏得游人醉，直把杭州作汴州。",
        "title": "题临安邸",
        "author": "林升",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_174": {
        "content": "半亩方塘一鉴开，天光云影共徘徊。问渠那得清如许？为有源头活水来。(那 通：哪)",
        "title": "观书有感二首·其一",
        "author": "朱熹",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_175": {
        "content": "律回岁晚冰霜少，春到人间草木知。便觉眼前生意满，东风吹水绿参差。",
        "title": "立春偶成",
        "author": "张栻",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_176": {
        "content": "胜日寻芳泗水滨，无边光景一时新。等闲识得东风面，万紫千红总是春。",
        "title": "春日",
        "author": "朱熹",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_177": {
        "content": "南浦春来绿一川，石桥朱塔两依然。年年送客横塘路，细雨垂杨系画船。",
        "title": "横塘",
        "author": "范成大",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_178": {
        "content": "自作新词韵最娇，小红低唱我吹箫。曲终过尽松陵路，回首烟波十四桥。",
        "title": "过垂虹",
        "author": "姜夔",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_179": {
        "content": "黄梅时节家家雨，青草池塘处处蛙。有约不来过夜半，闲敲棋子落灯花。",
        "title": "约客 / 有约",
        "author": "赵师秀",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_180": {
        "content": "水满田畴稻叶齐，日光穿树晓烟低。黄莺也爱新凉好，飞过青山影里啼。",
        "title": "新凉",
        "author": "徐玑",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_181": {
        "content": "绿遍山原白满川，子规声里雨如烟。乡村四月闲人少，才了蚕桑又插田。",
        "title": "乡村四月",
        "author": "翁卷",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_182": {
        "content": "美人台上昔欢娱，今日空台望五湖。残雪未融青草死，苦无麋鹿过姑苏。黄帽传呼睡不成，投稿细细激流冰。分明旧泊江南岸，舟尾春风飐客灯。千门列炬散林鸦，儿女相思未到家。应是不眠非守岁，小客春意入灯花。三生定自陆天随，又向顺松作客归。已拚新年舟上过，倩人和雪洗片衣。沙尾风回一棹寒，椒花今夕不登盘。百年草草都寒夜，自琢春词剪烛看。笠泽茫茫雁影微，玉峰重叠护云衣。长桥寂寞春寒放，只有诗人一舸归。桑间篝火却定蚕，风土相传我未谙。但得明年少行役，只裁白伫作春衫。少小知名翰墨场，十年心事只凄凉。旧时曾作梅花赋，研墨于今亦自香。环玦随波冷未销，古苔留雪卧墙腰。谁家玉笛吹春怨，看见鹅黄上柳条。",
        "title": "除放自石湖归苕溪",
        "author": "姜夔",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_183": {
        "content": "应怜屐齿印苍苔，小扣柴扉久不开。春色满园关不住，一枝红杏出墙来。",
        "title": "游园不值",
        "author": "叶绍翁",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_184": {
        "content": "两岸舟船各背驰，波痕交涉亦难为。只余鸥鹭无拘管，北去南来自在飞。",
        "title": "初入淮河四绝句·其三",
        "author": "杨万里",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_185": {
        "content": "乳鸭池塘水浅深，熟梅天气半阴晴。东园载酒西园醉，摘尽枇杷一树金。",
        "title": "初夏游张园",
        "author": "戴复古",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_186": {
        "content": "一片能教一断肠，可堪平砌更堆墙。飘如迁客来过岭，坠似骚人去赴湘。乱点莓苔多莫数，偶粘衣袖久犹香。东风谬掌花权柄，却忌孤高不主张。",
        "title": "落梅",
        "author": "刘克庄",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_187": {
        "content": "门外无人问落花，绿阴冉冉遍天涯。林莺啼到无声处，青草池塘独听蛙。",
        "title": "春暮",
        "author": "曹豳",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_188": {
        "content": "古木阴中系短篷，杖藜扶我过桥东。沾衣欲湿杏花雨，吹面不寒杨柳风。",
        "title": "绝句·古木阴中系短篷",
        "author": "志南",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_189": {
        "content": "江头落日照平沙，潮退渔船阁岸斜。白鸟一双临水立，见人惊起入芦花。",
        "title": "江村晚眺",
        "author": "戴复古",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_190": {
        "content": "辛苦遭逢起一经，干戈寥落四周星。山河破碎风飘絮，身世浮沉雨打萍。惶恐滩头说惶恐，零丁洋里叹零丁。人生自古谁无死，留取丹心照汗青。",
        "title": "过零丁洋",
        "author": "文天祥",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_191": {
        "content": "掷柳迁乔太有情，交交时作弄机声。洛阳三月花如锦，多少工夫织得成。",
        "title": "莺梭",
        "author": "刘克庄",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_192": {
        "content": "愁里高歌梁父吟，犹如金玉戛商音。十年勾践亡吴计，七日包胥哭楚心。秋送新鸿哀破国，昼行饥虎齧空林。胸中有誓深于海，肯使神州竟陆沉？",
        "title": "二砺",
        "author": "郑思肖",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_193": {
        "content": "小桃无主自开花，烟草茫茫带晚鸦。几处败垣围故井，向来一一是人家。",
        "title": "淮村兵后",
        "author": "戴复古",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_194": {
        "content": "花开不并百花丛，独立疏篱趣未穷。宁可枝头抱香死，何曾吹落北风中。",
        "title": "寒菊 / 画菊",
        "author": "郑思肖",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_195": {
        "content": "梅雪争春未肯降，骚人搁笔费评章。梅须逊雪三分白，雪却输梅一段香。",
        "title": "雪梅·其一",
        "author": "卢梅坡",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_196": {
        "content": "竹影和诗瘦，梅花入梦香。可怜今夜月，不肯下西厢。 ",
        "title": "绝句",
        "author": "王庭筠",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_197": {
        "content": "寒夜客来茶当酒，竹炉汤沸火初红。寻常一样窗前月，才有梅花便不同。",
        "title": "寒夜",
        "author": "杜耒",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_198": {
        "content": "十年无梦得还家，独立青峰野水涯。天地寂寥山雨歇，几生修得到梅花？",
        "title": "武夷山中",
        "author": "谢枋得",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_199": {
        "content": "西北天低五顶高，茫茫松海露灵鳌。太行直上犹千里，井底残山枉呼号。万壑千岩位置雄，偶从天巧见神功。湍溪已作风雷恶，更在云山气象中。山云吞吐翠微中，淡绿深青一万重。此景只应天上有，岂知身在妙高峰？",
        "title": "台山杂咏",
        "author": "元好问",
        "book": "古诗三百首",
        "dynasty": "金朝"
    },
    "poem_200": {
        "content": "惨澹龙蛇日斗争，干戈直欲尽生灵。高原出水山河改，战地风来草木腥。精卫有冤填瀚海，包胥无泪哭秦庭。并州豪杰知谁在，莫拟分军下井陉。",
        "title": "壬辰十二月车驾东狩后即事",
        "author": "元好问",
        "book": "古诗三百首",
        "dynasty": "金朝"
    },
    "poem_201": {
        "content": "枝间新绿一重重， 小蕾深藏数点红。爱惜芳心莫轻吐， 且教桃李闹春风。 ",
        "title": "同儿辈赋未开海棠",
        "author": "元好问",
        "book": "古诗三百首",
        "dynasty": "金朝"
    },
    "poem_202": {
        "content": "月儿弯弯照九州，几家欢乐几家愁。几家夫妇同罗帐，几个飘零在外头？",
        "title": "月儿弯弯照九州",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_203": {
        "content": "野店桃花红粉姿，陌头杨柳绿烟丝。不因送客东城去，过却春光总不知。",
        "title": "东城",
        "author": "赵孟頫",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_204": {
        "content": "客舟系缆柳阴旁，湖影侵篷夜气凉。 万顷波光摇月碎，一天风露藕花香。 ",
        "title": "临平泊舟",
        "author": "黄庚",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_205": {
        "content": "吾家洗砚池头树，个个花开淡墨痕。不要人夸颜色好，只流清气满乾坤。(版本一)我家洗砚池边树，朵朵花开淡墨痕。不要人夸好颜色，只留清气满乾坤。(版本二)",
        "title": "墨梅",
        "author": "王冕",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_206": {
        "content": "城雪初消荠菜生，角门深巷少人行。柳梢听得黄鹂语，此是春来第一声。",
        "title": "到京师",
        "author": "杨载",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_207": {
        "content": "花开红树乱莺啼，草长平湖白鹭飞。风日晴和人意好，夕阳箫鼓几船归。",
        "title": "湖上",
        "author": "徐元杰",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_208": {
        "content": "一击车中胆气豪，祖龙社稷已惊摇；如何十二金人外，犹有人间铁未销？",
        "title": "博浪沙",
        "author": "陈孚",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_209": {
        "content": "春草细还生，春雏养渐成。茸茸毛色起，应解自呼名。",
        "title": "画鸭",
        "author": "揭傒斯",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_210": {
        "content": "马蹄踏水乱明霞，醉袖迎风受落花。怪见溪童出门望，雀声先我到山家。",
        "title": "山家",
        "author": "刘因",
        "book": "古诗三百首",
        "dynasty": "宋代"
    },
    "poem_211": {
        "content": "牛羊散漫落日下，野草生香乳酪甜。卷地朔风沙似雪，家家行帐下毡帘。",
        "title": "上京即事",
        "author": "萨都剌",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_212": {
        "content": "细雨茸茸湿楝花，南风树树熟枇杷；徐行不记山深浅，一路莺啼送到家。",
        "title": "天平山中",
        "author": "杨基",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_213": {
        "content": "绿池芳草满晴波，春色都从雨里过。知是人家花落尽，菜畦今日蝶来多。",
        "title": "春暮西园",
        "author": "高启",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_214": {
        "content": "渡水复渡水，看花还看花。春风江上路，不觉到君家。",
        "title": "寻胡隐君",
        "author": "高启",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_215": {
        "content": "何处它年寄此生，山中江上总关情。无端绕屋长松树，尽把风声作雨声。",
        "title": "院中独坐",
        "author": "虞集",
        "book": "古诗三百首",
        "dynasty": "元代"
    },
    "poem_216": {
        "content": "春风一夜到衡阳，楚水燕山万里长。莫道春来便归去，江南虽好是他乡。",
        "title": "春雁",
        "author": "王恭",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_217": {
        "content": "下床着新衣，初学小姑拜。低头羞见人，双手结裙带。",
        "title": "幼女词",
        "author": "毛铉",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_218": {
        "content": "千锤万凿出深山，烈火焚烧若等闲。粉身碎骨全不怕，要留清白在人间。(一作：千锤万击出深山 / 千鎚万击出深山)(一作：粉骨碎身全不惜 / 粉身碎骨浑不怕 / 粉骨碎身全不怕)",
        "title": "石灰吟",
        "author": "于谦",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_219": {
        "content": "碧水丹山映杖藜，夕阳犹在小桥西。微吟不道惊溪鸟，飞入乱云深处啼。",
        "title": "题画",
        "author": "沈周",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_220": {
        "content": "莫将画竹论难易，刚道繁难简更难。君看萧萧只数叶，满堂风雨不胜寒。",
        "title": "柯敬仲墨竹",
        "author": "李东阳",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_221": {
        "content": "不炼金丹不坐禅，不为商贾不耕田。闲来写就青山卖，不使人间造孽钱。",
        "title": "言志",
        "author": "唐寅",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_222": {
        "content": "洞庭叶未下，潇湘秋欲生。高斋今夜雨，独卧武昌城。重以桑梓念，凄其江汉情。不知天外雁，何事乐长征？",
        "title": "在武昌作",
        "author": "徐祯卿",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_223": {
        "content": "汉江明月照归人，万里秋风一叶身。休把客衣轻浣濯，此中犹有帝京尘。",
        "title": "重赠吴国宾",
        "author": "边贡",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_224": {
        "content": "高田如楼梯，平田如棋局。白鹭忽飞来，点破秧针绿。",
        "title": "出郊",
        "author": "杨慎",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_225": {
        "content": "十二峰头秋草荒，冷烟寒月过瞿塘。青枫江上孤舟客，不听猿啼亦断肠。",
        "title": "竹枝词",
        "author": "何景明",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_226": {
        "content": "江水三千里，家书十五行。行行无别语，只道早还乡。",
        "title": "京师得家书",
        "author": "袁凯",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_227": {
        "content": "岸蓼疏红水荇青，茨菰花白小如蓱。双鬟短袖惭人见，背立船头自采菱。",
        "title": "发淮安",
        "author": "杨士奇",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_228": {
        "content": "暝色满西山，将军猎骑还。隔河见烽火，骄虏夜临关。",
        "title": "塞下曲",
        "author": "谢榛",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_229": {
        "content": "白羽如霜出塞寒，胡烽不断接长安。城头一片西山月，多少征人马上看。",
        "title": "塞上曲送元美",
        "author": "李攀龙",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_230": {
        "content": "浩气还太虚，丹心照千古。生平未报国，留作忠魂补。",
        "title": "就义诗",
        "author": "杨继盛",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_231": {
        "content": "南北驱驰报主情，江花边草笑平生。(边草 一作：边月)一年三百六十日，多是横戈马上行。",
        "title": "马上作",
        "author": "戚继光",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_232": {
        "content": "今日复今日，今日何其少！今日又不为，此事何其了？人生百年几今日，今日不为真可惜！若言姑待明朝至，明朝又有明朝事。为君聊赋今日诗，努力请从今日始。",
        "title": "今日诗",
        "author": "文嘉",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_233": {
        "content": "半生落魄已成翁,独立书斋啸晚风。笔底明珠无处卖,闲抛闲掷野藤中。",
        "title": "题《墨葡萄图》 / 题葡萄图",
        "author": "徐渭",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_234": {
        "content": "心同流水净，身与白云轻。寂寂深山暮，微闻钟磬声。",
        "title": "枕石",
        "author": "高攀龙",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_235": {
        "content": "湘山晴色远微微，尽日江头独醉归。不见两关传露布，尚闻三殿未垂衣。边筹自古无中下，朝论于今有是非。日暮平沙秋草乱，一双白鸟避人飞。",
        "title": "感事",
        "author": "袁宏道",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_236": {
        "content": "寂历秋江渔火稀，起看残月映林微。波光水鸟惊犹宿，露冷流萤湿不飞。",
        "title": "江宿",
        "author": "汤显祖",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_237": {
        "content": "朝求升，暮求合，近来贫汉难存活。早早开门拜闯王，管教大小都欢悦。杀牛羊，备酒浆，开了城门迎闯王，闯王来了不纳粮。吃他娘，着她娘，吃着不够有闯王。不当差，不纳粮，大家快活过一场。",
        "title": "闯王",
        "author": null,
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_238": {
        "content": "并刀昨夜匣中鸣，燕赵悲歌最不平；易水潺湲云草碧，可怜无处送荆卿！",
        "title": "渡易水",
        "author": "陈子龙",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_239": {
        "content": "关山虽胜路难堪，才上征鞍又解骖。十丈黄尘千尺雪，可知俱不似江南。",
        "title": "阻雪",
        "author": "吴伟业",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_240": {
        "content": "复楚情何极，亡秦气未平。雄风清角劲，落日大旗明。缟素酬家国，戈船决死生！胡笳千古恨，一片月临城。",
        "title": "即事",
        "author": "夏完淳",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_241": {
        "content": "鹧鸪声里夕阳西，陌上征人首尽低。遍地关山行不得，为谁辛苦尽情啼？",
        "title": "闻鹧鸪",
        "author": "尤侗",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_242": {
        "content": "形容不识识乡音，挑尽寒灯到夜深。故旧凭君休更说，老怀容易便沾襟。",
        "title": "乡人至夜话",
        "author": "李昌祺",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_243": {
        "content": "三年羁旅客，今日又南冠。无限河山泪，谁言天地宽！(河山 一作：山河)已知泉路近，欲别故乡难。毅魄归来日，灵旗空际看。",
        "title": "别云间",
        "author": "夏完淳",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_244": {
        "content": "居庸关上子规啼，饮马流泉落日低。雨雪自飞千嶂外，榆林只隔数峰西。",
        "title": "出居庸关",
        "author": "朱彝尊",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_245": {
        "content": "江干多是钓人居，柳陌菱塘一带疏；好是日斜风定后，半江红树卖鲈鱼。",
        "title": "真州绝句",
        "author": "王士祯",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_246": {
        "content": "江干多是钓人居，柳陌菱塘一带疏；好是日斜风定后，半江红树卖鲈鱼。",
        "title": "真州绝句",
        "author": "王士祯",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_247": {
        "content": "黄花古渡接芦溪，行过萍乡路渐低。吠犬鸣鸡村远近，乳鹅新鸭岸东西。丝缫细雨沾衣润，刀剪良苗出水齐。犹与湖南风土近，春深无处不耕犁。",
        "title": "自湘东驿遵陆至芦溪",
        "author": "查慎行",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_248": {
        "content": "月黑见渔灯，孤光一点萤。微微风簇浪，散作满河星。",
        "title": "舟夜书所见",
        "author": "查慎行",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_249": {
        "content": "到处陂塘决决流，垂杨百里罨平畴。行人便觉须眉绿，一路蝉声过许州。",
        "title": "过许州",
        "author": "沈德潜",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_250": {
        "content": "和雨还穿户，经风忽过墙。虽缘草成质，不借月为光。解识幽人意，请今聊处囊。君看落空阔，何异大星芒。",
        "title": "萤火",
        "author": "赵执信",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_251": {
        "content": "咬定青山不放松，立根原在破岩中。千磨万击还坚劲，任尔东西南北风。(坚劲 一作：韧)",
        "title": "竹石",
        "author": "郑燮",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_252": {
        "content": "晨起开门雪满山，雪晴云淡日光寒。檐流未滴梅花冻，一种清孤不等闲。",
        "title": "山中雪后",
        "author": "郑燮",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_253": {
        "content": "夜寒香界白，涧曲寺门通。月在众峰顶，泉流乱叶中。一灯群动息，孤磬四天空。归路畏逢虎，况闻岩下风。",
        "title": "灵隐寺月夜",
        "author": "厉鹗",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_254": {
        "content": "卖得鲜鱼二百钱，籴粮炊饭放归船。拔来湿苇烧难着，晒在垂杨古岸边。",
        "title": "渔家·卖得鲜鱼二百钱",
        "author": "郑燮",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_255": {
        "content": "百金买骏马，千金买美人；万金买高爵，何处买青春？",
        "title": "偶然作",
        "author": "屈复",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_256": {
        "content": "十里崎岖半里平，一峰才送一峰迎。青山似茧将人裹，不信前头有路行。",
        "title": "山行杂咏",
        "author": "袁枚",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_257": {
        "content": "爱子心无尽，归家喜及辰。寒衣针线密，家信墨痕新。见面怜清瘦，呼儿问苦辛。低徊愧人子，不敢叹风尘。",
        "title": "岁暮到家/岁末到家",
        "author": "蒋士铨",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_258": {
        "content": "船板胡在兹，而我寝其上。情知非江湖，梦寐亦风浪。",
        "title": "船板床",
        "author": "李梦阳",
        "book": "古诗三百首",
        "dynasty": "明代"
    },
    "poem_259": {
        "content": "牧童骑黄牛，歌声振林樾。意欲捕鸣蝉，忽然闭口立。",
        "title": "所见",
        "author": "袁枚",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_260": {
        "content": "秋夜访秋士，先闻水上音。半天凉月色，一笛酒人心。响遏碧云近，香传红藕深。相逢清露下，流影湿衣襟。",
        "title": "夜过借园见主人坐月下吹笛",
        "author": "袁枚",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_261": {
        "content": "爱好由来下笔难，一诗千改始心安。阿婆还似初笄女，头未梳成不许看。",
        "title": "遣兴",
        "author": "袁枚",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_262": {
        "content": "山色江声共寂寥，十三陵树晚萧萧。中原事业如江左，芳草何须怨六朝。",
        "title": "秣陵怀古",
        "author": "纳兰性德",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_263": {
        "content": "李杜诗篇万口传，至今已觉不新鲜。江山代有才人出，各领风骚数百年。",
        "title": "论诗五首·其二",
        "author": "赵翼",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_264": {
        "content": "搴帷拜母河梁去，白发愁看泪眼枯。惨惨柴门风雪夜，此时有子不如无。",
        "title": "别老母",
        "author": "黄景仁",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_265": {
        "content": "布谷飞飞劝早耕，舂锄扑扑趁春睛。千层石树遥行路，一带山田放水声。",
        "title": "山行·布谷飞飞劝早耕",
        "author": "姚鼐",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_266": {
        "content": "九州生气恃风雷，万马齐喑究可哀。我劝天公重抖擞，不拘一格降人才。",
        "title": "己亥杂诗·其二百二十",
        "author": "龚自珍",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_267": {
        "content": "大道青楼望不遮，年时系马醉流霞。风前带是同心结，杯底人如解语花。下杜城边南北路，上阑门外去来车。匆匆觉得扬州梦，检点闲愁在鬓华。唤起窗前尚宿酲，啼鹃催去又声声。丹青旧誓相如札，禅榻经时杜牧情。别后相思空一水，重来回首已三生。云阶月地依然在，细逐空香百遍行。遮莫临行念我频，竹枝留涴泪痕新。多缘刺史无坚约，岂视萧郎作路人。望里彩云疑冉冉，愁边春水故粼粼。珊瑚百尺珠千斛，难换罗敷未嫁身。从此音尘各悄然，春山如黛草如烟。泪添吴苑三更雨，恨惹邮亭一夜眠。讵有青乌缄别句，聊将锦瑟记流年。他时脱便微之过，百转千回只自怜。",
        "title": "感旧四首",
        "author": "黄景仁",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_268": {
        "content": "金粉东南十五州，万重恩怨属名流。牢盆狎客操全算，团扇才人踞上游。避席畏闻文字狱，著书都为稻粱谋。田横五百人安在，难道归来尽列侯？",
        "title": "咏史",
        "author": "龚自珍",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_269": {
        "content": "浩荡离愁白日斜，吟鞭东指即天涯。落红不是无情物，化作春泥更护花。",
        "title": "己亥杂诗·其五",
        "author": "龚自珍",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_270": {
        "content": "草长莺飞二月天，拂堤杨柳醉春烟。儿童散学归来早，忙趁东风放纸鸢。",
        "title": "村居",
        "author": "高鼎",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_271": {
        "content": "远看山有色，近听水无声。春去花还在，人来鸟不惊。",
        "title": "画",
        "author": "王维",
        "book": "古诗三百首",
        "dynasty": "唐代"
    },
    "poem_272": {
        "content": "莫唱当年长恨歌，人间亦自有银河。石壕村里夫妻别，泪比长生殿上多。",
        "title": "马嵬",
        "author": "袁枚",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_273": {
        "content": "望门投止思张俭，忍死须臾待杜根。我自横刀向天笑，去留肝胆两昆仑。(版本一)望门投趾怜张俭，直谏陈书愧杜根。手掷欧刀仰天笑，留将公罪后人论。(版本二)",
        "title": "狱中题壁",
        "author": "谭嗣同",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_274": {
        "content": "春愁难遣强看山，往事惊心泪欲潸。四百万人同一哭，去年今日割台湾。",
        "title": "春愁",
        "author": "丘逢甲",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_275": {
        "content": "不惜千金买宝刀，貂裘换酒也堪豪。一腔热血勤珍重，洒去犹能化碧涛。",
        "title": "对酒",
        "author": "秋瑾",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_276": {
        "content": "诗界千年靡靡风，兵魂销尽国魂空。集中什九从军乐，亘古男儿一放翁。",
        "title": "读陆放翁集",
        "author": "梁启超",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_277": {
        "content": "邹容吾小弟，被发下瀛州。快剪刀除辫，干牛肉作餱。英雄一入狱，天地亦悲秋。临命须掺手，乾坤只两头！",
        "title": "狱中赠邹容",
        "author": "章炳麟",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_278": {
        "content": "浓似春云淡似烟，参差绿到大江边。斜阳流水推篷坐，翠色随人欲上船。",
        "title": "富春至严陵山水甚佳",
        "author": "纪昀",
        "book": "古诗三百首",
        "dynasty": "清代"
    },
    "poem_279": {
        "content": "寥落古行宫，宫花寂寞红。白头宫女在，闲坐说玄宗。",
        "title": "行宫",
        "author": "元稹",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_280": {
        "content": "空山不见人，但闻人语响。返景入深林，复照青苔上。",
        "title": "鹿柴",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_281": {
        "content": "君自故乡来，应知故乡事。来日绮窗前，寒梅著花未？",
        "title": "杂诗三首·其二",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_282": {
        "content": "三日入厨下，洗手作羹汤。未谙姑食性，先遣小姑尝。",
        "title": "新嫁娘词",
        "author": "王建",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_283": {
        "content": "红豆生南国，春来发几枝。愿君多采撷，此物最相思。",
        "title": "相思",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_284": {
        "content": "山中相送罢，日暮掩柴扉。春草明年绿，王孙归不归？(明年 一作：年年)",
        "title": "送别 / 山中送别 / 送友",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_285": {
        "content": "绿蚁新醅酒，红泥小火炉。晚来天欲雪，能饮一杯无？",
        "title": "问刘十九",
        "author": "白居易",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_286": {
        "content": "白日依山尽，黄河入海流。欲穷千里目，更上一层楼。",
        "title": "登鹳雀楼",
        "author": "王之涣",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_287": {
        "content": "独坐幽篁里，弹琴复长啸。深林人不知，明月来相照。",
        "title": "竹里馆",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_288": {
        "content": "鸣筝金粟柱，素手玉房前。欲得周郎顾，时时误拂弦。",
        "title": "听筝",
        "author": "李端",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_289": {
        "content": "向晚意不适，驱车登古原。夕阳无限好，只是近黄昏。",
        "title": "乐游原 / 登乐游原",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_290": {
        "content": "功盖三分国，名成八阵图。（名成 一作：名高）江流石不转，遗恨失吞吴。",
        "title": "八阵图",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_291": {
        "content": "床前明月光，疑是地上霜。举头望明月，低头思故乡。",
        "title": "静夜思",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_292": {
        "content": "春眠不觉晓，处处闻啼鸟。夜来风雨声，花落知多少。",
        "title": "春晓",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_293": {
        "content": "岭外音书断，经冬复历春。近乡情更怯，不敢问来人。",
        "title": "渡汉江",
        "author": "宋之问",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_294": {
        "content": "美人卷珠帘，深坐颦蛾眉。(蛾眉 一作：蹙)但见泪痕湿，不知心恨谁。",
        "title": "怨情",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_295": {
        "content": "千山鸟飞绝，万径人踪灭。孤舟蓑笠翁，独钓寒江雪。",
        "title": "江雪",
        "author": "柳宗元",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_296": {
        "content": "移舟泊烟渚，日暮客愁新。野旷天低树，江清月近人。",
        "title": "宿建德江",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_297": {
        "content": "怀君属秋夜，散步咏凉天。空山松子落，幽人应未眠。",
        "title": "秋夜寄邱员外 / 秋夜寄丘二十二员外",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_298": {
        "content": "终南阴岭秀，积雪浮云端。林表明霁色，城中增暮寒。",
        "title": "终南望余雪",
        "author": "祖咏",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_299": {
        "content": "故国三千里，深宫二十年。一声何满子，双泪落君前。",
        "title": "宫词·故国三千里",
        "author": "张祜",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_300": {
        "content": "打起黄莺儿，莫教枝上啼。啼时惊妾梦，不得到辽西。",
        "title": "春怨 / 伊州歌",
        "author": "金昌绪",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_301": {
        "content": "松下问童子，言师采药去。只在此山中，云深不知处。",
        "title": "寻隐者不遇 / 孙革访羊尊师诗",
        "author": "贾岛",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_302": {
        "content": "归山深浅去，须尽丘壑美。莫学武陵人，暂游桃源里。",
        "title": "崔九欲往南山马上口号与别 / 留别王维 / 送崔九",
        "author": "裴迪",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_303": {
        "content": "苍苍竹林寺，杳杳钟声晚。荷笠带斜阳，青山独归远。(斜阳 一作：夕阳)",
        "title": "送灵澈上人",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_304": {
        "content": "泠泠七弦上，静听松风寒。(七弦  一作：七丝)古调虽自爱，今人多不弹。",
        "title": "听弹琴",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_305": {
        "content": "寒雨连江夜入吴，平明送客楚山孤。洛阳亲友如相问，一片冰心在玉壶。",
        "title": "芙蓉楼送辛渐",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_306": {
        "content": "昨夜裙带解，今朝蟢子飞。铅华不可弃，莫是藁砧归。",
        "title": "玉台体",
        "author": "权德舆",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_307": {
        "content": "北斗七星高，哥舒夜带刀。至今窥牧马，不敢过临洮。",
        "title": "哥舒歌",
        "author": "西鄙人",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_308": {
        "content": "闺中少妇不知愁，春日凝妆上翠楼。忽见陌头杨柳色，悔教夫婿觅封侯。",
        "title": "闺怨",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_309": {
        "content": "昨夜风开露井桃，未央前殿月轮高。 平阳歌舞新承宠，帘外春寒赐锦袍。",
        "title": "春宫曲",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_310": {
        "content": "独在异乡为异客，每逢佳节倍思亲。遥知兄弟登高处，遍插茱萸少一人。",
        "title": "九月九日忆山东兄弟",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_311": {
        "content": "葡萄美酒夜光杯，欲饮琵琶马上催。醉卧沙场君莫笑，古来征战几人回？",
        "title": "凉州词二首·其一",
        "author": "王翰",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_312": {
        "content": "孤云将野鹤，岂向人间住。莫买沃洲山，时人已知处。",
        "title": "送方外上人 / 送上人",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_313": {
        "content": "寂寂花时闭院门，美人相并立琼轩。 含情欲说宫中事，鹦鹉前头不敢言。",
        "title": "宫词 / 宫中词",
        "author": "朱庆馀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_314": {
        "content": "泪湿罗巾梦不成，夜深前殿按歌声。 红颜未老恩先断，斜倚薰笼坐到明。",
        "title": "后宫词",
        "author": "白居易",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_315": {
        "content": "洞房昨夜停红烛，待晓堂前拜舅姑。 妆罢低声问夫婿，画眉深浅入时无。",
        "title": "近试上张籍水部 / 近试上张水部 / 闺意献张水部",
        "author": "朱庆馀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_316": {
        "content": "故人西辞黄鹤楼，烟花三月下扬州。孤帆远影碧空尽，唯见长江天际流。(唯 通：惟)",
        "title": "黄鹤楼送孟浩然之广陵",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_317": {
        "content": "朝辞白帝彩云间，千里江陵一日还。两岸猿声啼不住，轻舟已过万重山。",
        "title": "早发白帝城 / 白帝下江陵",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_318": {
        "content": "回乐峰前沙似雪，受降城外月如霜。(回乐 一作：回乐）不知何处吹芦管，一夜征人尽望乡。",
        "title": "夜上受降城闻笛",
        "author": "李益",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_319": {
        "content": "故园东望路漫漫，双袖龙钟泪不干。 马上相逢无纸笔，凭君传语报平安。",
        "title": "逢入京使",
        "author": "岑参",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_320": {
        "content": "宣室求贤访逐臣，贾生才调更无伦。可怜夜半虚前席，不问苍生问鬼神。",
        "title": "贾生",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_321": {
        "content": "乘兴南游不戒严，九重谁省谏书函。 春风举国裁宫锦，半作障泥半作帆。",
        "title": "隋宫 / 隋堤",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_322": {
        "content": "瑶池阿母绮窗开，黄竹歌声动地哀。 八骏日行三万里，穆王何事不重来。",
        "title": "瑶池",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_323": {
        "content": "云母屏风烛影深，长河渐落晓星沉。嫦娥应悔偷灵药，碧海青天夜夜心。",
        "title": "嫦娥",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_324": {
        "content": "君问归期未有期，巴山夜雨涨秋池。 何当共剪西窗烛，却话巴山夜雨时。",
        "title": "夜雨寄北",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_325": {
        "content": "为有云屏无限娇，凤城寒尽怕春宵。 无端嫁得金龟婿，辜负香衾事早朝。",
        "title": "为有",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_326": {
        "content": "岐王宅里寻常见，崔九堂前几度闻。 正是江南好风景，落花时节又逢君。",
        "title": "江南逢李龟年",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_327": {
        "content": "嵩云秦树久离居，双鲤迢迢一纸书。 休问梁园旧宾客，茂陵秋雨病相如。",
        "title": "寄令狐郎中",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_328": {
        "content": "青山隐隐水迢迢，秋尽江南草未凋。二十四桥明月夜，玉人何处教吹箫？",
        "title": "寄扬州韩绰判官",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_329": {
        "content": "落魄江南载酒行，楚腰纤细掌中轻。(江南 一作：江湖；纤细 一作：肠断)十年一觉扬州梦，赢得青楼薄幸名。",
        "title": "遣怀",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_330": {
        "content": "繁华事散逐香尘，流水无情草自春。日暮东风怨啼鸟，落花犹似坠楼人。",
        "title": "金谷园",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_331": {
        "content": "娉娉袅袅十三余，豆蔻梢头二月初。春风十里扬州路，卷上珠帘总不如。多情却似总无情，唯觉樽前笑不成。蜡烛有心还惜别，替人垂泪到天明。",
        "title": "赠别二首",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_332": {
        "content": "银烛秋光冷画屏，轻罗小扇扑流萤。天阶夜色凉如水，卧看牵牛织女星。(天阶 一作：天街；卧看 一作：坐看)",
        "title": "秋夕",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_333": {
        "content": "清时有味是无能，闲爱孤云静爱僧。 欲把一麾江海去，乐游原上望昭陵。",
        "title": "将赴吴兴登乐游原一绝",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_334": {
        "content": "折戟沉沙铁未销，自将磨洗认前朝。东风不与周郎便，铜雀春深锁二乔。",
        "title": "赤壁",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_335": {
        "content": "烟笼寒水月笼沙，夜泊秦淮近酒家。商女不知亡国恨，隔江犹唱后庭花。",
        "title": "泊秦淮",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_336": {
        "content": "岁岁金河复玉关，朝朝马策与刀环。 三春白雪归青冢，万里黄河绕黑山。",
        "title": "征人怨 / 征怨",
        "author": "柳中庸",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_337": {
        "content": "多情却似总无情，唯觉樽前笑不成。蜡烛有心还惜别，替人垂泪到天明。",
        "title": "赠别",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_338": {
        "content": "谁谓伤心画不成，画人心逐世人情。 君看六幅南朝事，老木寒云满故城。",
        "title": "金陵图",
        "author": "韦庄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_339": {
        "content": "独怜幽草涧边生，上有黄鹂深树鸣。 春潮带雨晚来急，野渡无人舟自横。",
        "title": "滁州西涧",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_340": {
        "content": "隐隐飞桥隔野烟，石矶西畔问渔船。 桃花尽日随流水，洞在清溪何处边。",
        "title": "桃花溪",
        "author": "张旭",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_341": {
        "content": "别梦依依到谢家，小廊回合曲阑斜。多情只有春庭月，犹为离人照落花。",
        "title": "寄人",
        "author": "张泌",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_342": {
        "content": "金陵津渡小山楼，一宿行人自可愁。 潮落夜江斜月里，两三星火是瓜州。",
        "title": "题金陵渡",
        "author": "张祜",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_343": {
        "content": "禁门宫树月痕过，媚眼惟看宿鹭窠。斜拔玉钗灯影畔，剔开红焰救飞蛾。",
        "title": "赠内人",
        "author": "张祜",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_344": {
        "content": "日光斜照集灵台，红树花迎晓露开。 昨夜上皇新授箓，太真含笑入帘来。",
        "title": "集灵台·其一",
        "author": "张祜",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_345": {
        "content": "虢国夫人承主恩，平明骑马入宫门。却嫌脂粉污颜色，淡扫峨眉朝至尊。",
        "title": "集灵台·其二",
        "author": "张祜",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_346": {
        "content": "誓扫匈奴不顾身，五千貂锦丧胡尘。可怜无定河边骨，犹是春闺梦里人！(春闺 一作：深闺)",
        "title": "陇西行四首·其二",
        "author": "陈陶",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_347": {
        "content": "近寒食雨草萋萋，著麦苗风柳映堤。等是有家归未得，杜鹃休向耳边啼。",
        "title": "杂诗",
        "author": null,
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_348": {
        "content": "少小离家老大回，乡音无改鬓毛衰。(鬓毛衰 一作：鬓毛催)儿童相见不相识，笑问客从何处来。",
        "title": "回乡偶书二首·其一",
        "author": "贺知章",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_349": {
        "content": "朱雀桥边野草花，乌衣巷口夕阳斜。 旧时王谢堂前燕，飞入寻常百姓家。",
        "title": "乌衣巷",
        "author": "刘禹锡",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_350": {
        "content": "月落乌啼霜满天，江枫渔火对愁眠。姑苏城外寒山寺，夜半钟声到客船。",
        "title": "枫桥夜泊 / 夜泊枫江",
        "author": "张继",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_351": {
        "content": "纱窗日落渐黄昏，金屋无人见泪痕。 寂寞空庭春欲晚，梨花满地不开门。",
        "title": "春怨",
        "author": "刘方平",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_352": {
        "content": "冰簟银床梦不成，碧天如水夜云轻。 雁声远过潇湘去，十二楼中月自明。",
        "title": "瑶瑟怨",
        "author": "温庭筠",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_353": {
        "content": "春城无处不飞花，寒食东风御柳斜。 日暮汉宫传蜡烛，轻烟散入五侯家。",
        "title": "寒食 / 寒食日即事",
        "author": "韩翃",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_354": {
        "content": "城阙辅三秦，风烟望五津。与君离别意，同是宦游人。海内存知己，天涯若比邻。无为在歧路，儿女共沾巾。",
        "title": "送杜少府之任蜀州 / 送杜少府之任蜀川",
        "author": "王勃",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_355": {
        "content": "玄宗回马杨妃死，云雨难忘日月新。终是圣明天子事，景阳宫井又何人。",
        "title": "马嵬坡",
        "author": "郑畋",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_356": {
        "content": "万壑树参天，千山响杜鹃。山中一夜雨，树杪百重泉。汉女输橦布，巴人讼芋田。文翁翻教授，不敢倚先贤。",
        "title": "送梓州李使君",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_357": {
        "content": "长乐宫连上苑春，玉楼金殿艳歌新。 君门一入无由出，唯有宫莺得见人。",
        "title": "宫词",
        "author": "顾况",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_358": {
        "content": "楚塞三湘接，荆门九派通。江流天地外，山色有无中。 郡邑浮前浦，波澜动远空。襄阳好风日，留醉与山翁。",
        "title": "汉江临泛 / 汉江临眺",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_359": {
        "content": "更深月色半人家，北斗阑干南斗斜。 今夜偏知春气暖，虫声新透绿窗纱。",
        "title": "月夜 / 夜月",
        "author": "刘方平",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_360": {
        "content": "太乙近天都，连山接海隅。白云回望合，青霭入看无。 分野中峰变，阴晴众壑殊。欲投人处宿，隔水问樵夫。",
        "title": "终南山",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_361": {
        "content": "新妆宜面下朱楼，深锁春光一院愁。 行到中庭数花朵，蜻蜓飞上玉搔头。",
        "title": "和乐天春词 / 春词",
        "author": "刘禹锡",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_362": {
        "content": "中岁颇好道，晚家南山陲。兴来每独往，胜事空自知。行到水穷处，坐看云起时。偶然值林叟，谈笑无还期。",
        "title": "终南别业 / 初至山中 / 入山寄城中故人",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_363": {
        "content": "晚年唯好静，万事不关心。自顾无长策，空知返旧林。 松风吹解带，山月照弹琴。君问穷通理，渔歌入浦深。",
        "title": "酬张少府",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_364": {
        "content": "空山新雨后，天气晚来秋。明月松间照，清泉石上流。竹喧归浣女，莲动下渔舟。随意春芳歇，王孙自可留。",
        "title": "山居秋暝",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_365": {
        "content": "清川带长薄，车马去闲闲。流水如有意，暮禽相与还。 荒城临古渡，落日满秋山。迢递嵩高下，归来且闭关。",
        "title": "归嵩山作",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_366": {
        "content": "寒山转苍翠，秋水日潺湲。倚杖柴门外，临风听暮蝉。渡头馀落日，墟里上孤烟。(馀 一作 余)复值接舆醉，狂歌五柳前。",
        "title": "辋川闲居赠裴秀才迪",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_367": {
        "content": "客路青山外，行舟绿水前。(青山外 一作：青山下)潮平两岸阔，风正一帆悬。海日生残夜，江春入旧年。乡书何处达？归雁洛阳边。",
        "title": "次北固山下",
        "author": "王湾",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_368": {
        "content": "碧阑干外绣帘垂，猩血屏风画折枝。 八尺龙须方锦褥，已凉天气未寒时。",
        "title": "已凉",
        "author": "韩偓",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_369": {
        "content": "不知香积寺，数里入云峰。古木无人径，深山何处钟。泉声咽危石，日色冷青松。薄暮空潭曲，安禅制毒龙。",
        "title": "过香积寺",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_370": {
        "content": "离离原上草，一岁一枯荣。野火烧不尽，春风吹又生。远芳侵古道，晴翠接荒城。又送王孙去，萋萋满别情。",
        "title": "草 / 赋得古原草送别",
        "author": "白居易",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_371": {
        "content": "故人江海别，几度隔山川。乍见翻疑梦，相悲各问年。孤灯寒照雨，深竹暗浮烟。更有明朝恨，离杯惜共传。",
        "title": "云阳馆与韩绅宿别",
        "author": "司空曙",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_372": {
        "content": "静夜四无邻，荒居旧业贫。雨中黄叶树，灯下白头人。以我独沉久，愧君相见频。平生自有分，况是蔡家亲。",
        "title": "喜外弟卢纶见宿",
        "author": "司空曙",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_373": {
        "content": "世乱同南去，时清独北还。他乡生白发，旧国见青山。 晓月过残垒，繁星宿故关。寒禽与衰草，处处伴愁颜。",
        "title": "贼平后送人北归",
        "author": "司空曙",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_374": {
        "content": "阳月南飞雁，传闻至此回。我行殊未已，何日复归来。 江静潮初落，林昏瘴不开。明朝望乡处，应见陇头梅。",
        "title": "题大庾岭北驿",
        "author": "宋之问",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_375": {
        "content": "蜀僧抱绿绮，西下峨眉峰。为我一挥手，如听万壑松。 客心洗流水，馀响入霜钟。不觉碧山暮，秋云暗几重。",
        "title": "听蜀僧濬弹琴 / 听蜀僧浚弹琴",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_376": {
        "content": "牛渚西江夜，青天无片云。登舟望秋月，空忆谢将军。余亦能高咏，斯人不可闻。明朝挂帆席，枫叶落纷纷。(挂帆 一作：去)",
        "title": "夜泊牛渚怀古",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_377": {
        "content": "吾爱孟夫子，风流天下闻。红颜弃轩冕，白首卧松云。 醉月频中圣，迷花不事君。高山安可仰，徒此揖清芬。",
        "title": "赠孟浩然",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_378": {
        "content": "渡远荆门外，来从楚国游。山随平野尽，江入大荒流。月下飞天镜，云生结海楼。仍怜故乡水，万里送行舟。",
        "title": "渡荆门送别",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_379": {
        "content": "十年离乱后，长大一相逢。问姓惊初见，称名忆旧容。别来沧海事，语罢暮天钟。明日巴陵道，秋山又几重。",
        "title": "喜见外弟又言别",
        "author": "李益",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_380": {
        "content": "联步趋丹陛，分曹限紫微。晓随天仗入，暮惹御香归。 白发悲花落，青云羡鸟飞。圣朝无阙事，自觉谏书稀。",
        "title": "寄左省杜拾遗",
        "author": "岑参",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_381": {
        "content": "青山横北郭，白水绕东城。此地一为别，孤蓬万里征。浮云游子意，落日故人情。挥手自兹去，萧萧班马鸣。",
        "title": "送友人",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_382": {
        "content": "客去波平槛，蝉休露满枝。永怀当此节，倚立自移时。 北斗兼春远，南陵寓使迟。天涯占梦数，疑误有新知。",
        "title": "凉思",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_383": {
        "content": "残阳西入崦，茅屋访孤僧。落叶人何在，寒云路几层。 独敲初夜磬，闲倚一枝藤。世界微尘里，吾宁爱与憎。",
        "title": "北青萝",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_384": {
        "content": "本以高难饱，徒劳恨费声。五更疏欲断，一树碧无情。 薄宦梗犹泛，故园芜已平。烦君最相警，我亦举家清。",
        "title": "蝉",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_385": {
        "content": "凄凉宝剑篇，羁泊欲穷年。黄叶仍风雨，青楼自管弦。新知遭薄俗，旧好隔良缘。心断新丰酒，销愁斗几千。",
        "title": "风雨",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_386": {
        "content": "昔闻洞庭水，今上岳阳楼。吴楚东南坼，乾坤日夜浮。亲朋无一字，老病有孤舟。戎马关山北，凭轩涕泗流。",
        "title": "登岳阳楼",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_387": {
        "content": "高阁客竟去，小园花乱飞。参差连曲陌，迢递送斜晖。 肠断未忍扫，眼穿仍欲归。芳心向春尽，所得是沾衣。",
        "title": "落花",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_388": {
        "content": "远送从此别，青山空复情。几时杯重把，昨夜月同行。 列郡讴歌惜，三朝出入荣。江村独归处，寂寞养残生。",
        "title": "奉济驿重送严公四韵",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_389": {
        "content": "今夜鄜州月，闺中只独看。遥怜小儿女，未解忆长安。 香雾云鬟湿，清辉玉臂寒。何时倚虚幌，双照泪痕干。",
        "title": "月夜",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_390": {
        "content": "凉风起天末，君子意如何。鸿雁几时到，江湖秋水多。文章憎命达，魑魅喜人过。应共冤魂语，投诗赠汨罗。",
        "title": "天末怀李白",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_391": {
        "content": "细草微风岸，危樯独夜舟。星垂平野阔，月涌大江流。名岂文章著，官应老病休。飘飘何所似，天地一沙鸥。",
        "title": "旅夜书怀",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_392": {
        "content": "此道昔归顺，西郊胡正繁。至今残破胆，应有未招魂。 近得归京邑，移官岂至尊。无才日衰老，驻马望千门。",
        "title": "至德二载甫自京金光门出问道归凤翔乾元初…有悲往事",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_393": {
        "content": "戍鼓断人行，边秋一雁声。(边秋 一作:秋边)露从今夜白，月是故乡明。有弟皆分散，无家问死生。寄书长不达，况乃未休兵。",
        "title": "月夜忆舍弟",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_394": {
        "content": "他乡复行役，驻马别孤坟。近泪无干土，低空有断云。 对棋陪谢傅，把剑觅徐君。唯见林花落，莺啼送客闻。",
        "title": "别房太尉墓",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_395": {
        "content": "国破山河在，城春草木深。感时花溅泪，恨别鸟惊心。烽火连三月，家书抵万金。白头搔更短，浑欲不胜簪。",
        "title": "春望",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_396": {
        "content": "旅馆无良伴，凝情自悄然。寒灯思旧事，断雁警愁眠。远梦归侵晓，家书到隔年。沧江好烟月，门系钓鱼船。",
        "title": "旅宿",
        "author": "杜牧",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_397": {
        "content": "早被婵娟误，欲妆临镜慵。承恩不在貌，教妾若为容。 风暖鸟声碎，日高花影重。年年越溪女，相忆采芙蓉。",
        "title": "春宫怨",
        "author": "杜荀鹤",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_398": {
        "content": "独有宦游人，偏惊物候新。云霞出海曙，梅柳渡江春。淑气催黄鸟，晴光转绿蘋。忽闻歌古调，归思欲沾巾。",
        "title": "和晋陵陆丞早春游望",
        "author": "杜审言",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_399": {
        "content": "花隐掖垣暮，啾啾栖鸟过。星临万户动，月傍九霄多。 不寝听金钥，因风想玉珂。明朝有封事，数问夜如何。",
        "title": "春宿左省",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_400": {
        "content": "山暝闻猿愁，沧江急夜流。风鸣两岸叶，月照一孤舟。 建德非吾土，维扬忆旧游。还将两行泪，遥寄海西头。",
        "title": "宿桐庐江寄广陵旧游",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_401": {
        "content": "木落雁南度，北风江上寒。我家襄水曲，遥隔楚云端。乡泪客中尽，孤帆天际看。(孤帆 一作：归帆)迷津欲有问，平海夕漫漫。",
        "title": "早寒江上有怀 / 早寒有怀 / 江上思归",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_402": {
        "content": "寂寂竟何待，朝朝空自归。欲寻芳草去，惜与故人违。当路谁相假，知音世所稀。只应守寂寞，还掩故园扉。",
        "title": "留别王侍御维 / 留别王维",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_403": {
        "content": "北阙休上书，南山归敝庐。不才明主弃，多病故人疏。 白发催年老，青阳逼岁除。永怀愁不寐，松月夜窗虚。",
        "title": "岁暮归南山 / 归故园作 / 归终南山",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_404": {
        "content": "故人具鸡黍，邀我至田家。绿树村边合，青山郭外斜。开轩面场圃，把酒话桑麻。待到重阳日，还来就菊花。",
        "title": "过故人庄",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_405": {
        "content": "一丘常欲卧，三径苦无资。北土非吾愿，东林怀我师。黄金燃桂尽，壮志逐年衰。日夕凉风至，闻蝉但益悲。",
        "title": "秦中感秋寄远上人 / 秦中寄远上人",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_406": {
        "content": "八月湖水平，涵虚混太清。气蒸云梦泽，波撼岳阳城。 欲济无舟楫，端居耻圣明。坐观垂钓者，徒有羡鱼情。",
        "title": "望洞庭湖赠张丞相 / 临洞庭",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_407": {
        "content": "闻道黄龙戍，频年不解兵。可怜闺里月，长在汉家营。少妇今春意，良人昨夜情。谁能将旗鼓，一为取龙城。",
        "title": "杂诗三首·其三",
        "author": "沈佺期",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_408": {
        "content": "人事有代谢，往来成古今。江山留胜迹，我辈复登临。水落鱼梁浅，天寒梦泽深。羊公碑尚在，读罢泪沾襟。(尚在 一作：字在)",
        "title": "与诸子登岘山",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_409": {
        "content": "清瑟怨遥夜，绕弦风雨哀。孤灯闻楚角，残月下章台。 芳草已云暮，故人殊未来。乡书不可寄，秋雁又南回。",
        "title": "章台夜思",
        "author": "韦庄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_410": {
        "content": "江汉曾为客，相逢每醉还。浮云一别后，流水十年间。欢笑情如旧，萧疏鬓已斑。何因不归去？淮上有秋山。",
        "title": "淮上喜会梁川故人 / 淮上喜会梁州故人",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_411": {
        "content": "楚江微雨里，建业暮钟时。漠漠帆来重，冥冥鸟去迟。 海门深不见，浦树远含滋。相送情无限，沾襟比散丝。",
        "title": "赋得暮雨送李胄 / 赋得暮雨送李曹",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_412": {
        "content": "夫子何为者，栖栖一代中。地犹鄹氏邑，宅即鲁王宫。 叹凤嗟身否，伤麟怨道穷。今看两楹奠，当与梦时同。",
        "title": "经邹鲁祭孔子而叹之",
        "author": "李隆基",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_413": {
        "content": "灞原风雨定，晚见雁行频。落叶他乡树，寒灯独夜人。空园白露滴，孤壁野僧邻。寄卧郊扉久，何年致此身。",
        "title": "灞上秋居",
        "author": "马戴",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_414": {
        "content": "露气寒光集，微阳下楚丘。猿啼洞庭树，人在木兰舟。广泽生明月，苍山夹乱流。云中君不见，竟夕自悲秋。",
        "title": "楚江怀古三首·其一",
        "author": "马戴",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_415": {
        "content": "林卧愁春尽，搴帷览物华。忽逢青鸟使，邀入赤松家。 丹灶初开火，仙桃正落花。童颜若可驻，何惜醉流霞。",
        "title": "清明日宴梅道士房 / 宴梅道士山房",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_416": {
        "content": "迢递三巴路，羁危万里身。乱山残雪夜，孤烛异乡人。渐与骨肉远，转于僮仆亲。那堪正飘泊，明日岁华新。",
        "title": "除夜 / 巴山道中除夜书怀 / 除夜有怀",
        "author": "崔涂",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_417": {
        "content": "几行归塞尽，念尔独何之。暮雨相呼失，寒塘欲下迟。渚云低暗度，关月冷相随。未必逢矰缴，孤飞自可疑。",
        "title": "孤雁二首·其二",
        "author": "崔涂",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_418": {
        "content": "清晨入古寺，初日照高林。竹径通幽处，禅房花木深。山光悦鸟性，潭影空人心。万籁此都寂，但余钟磬音。(版本一)清晨入古寺，初日照高林。曲径通幽处，禅房花木深。山光悦鸟性，潭影空人心。万籁此俱寂，惟余钟磬音。(版本二)清晨入古寺，初日照高林。竹径通幽处，禅房花木深。山光悦鸟性，潭影空人心。万籁此俱寂，但余钟磬音。(版本三)清晨入古寺，初日照高林。曲径通幽处，禅房花木深。山光悦鸟性，潭影空人心。万籁此俱寂，但余钟磬音。(版本四)",
        "title": "题破山寺后禅院",
        "author": "常建",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_419": {
        "content": "海上生明月，天涯共此时。情人怨遥夜，竟夕起相思。灭烛怜光满，披衣觉露滋。不堪盈手赠，还寝梦佳期。",
        "title": "望月怀远 / 望月怀古",
        "author": "张九龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_420": {
        "content": "调角断清秋，征人倚戍楼。春风对青冢，白日落梁州。 大汉无兵阻，穷边有客游。蕃情似此水，长愿向南流。",
        "title": "书边事",
        "author": "张乔",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_421": {
        "content": "前年伐月支，城上没全师。蕃汉断消息，死生长别离。 无人收废帐，归马识残旗。欲祭疑君在，天涯哭此时。",
        "title": "没蕃故人",
        "author": "张籍",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_422": {
        "content": "乡心新岁切，天畔独潸然。老至居人下，春归在客先。 岭猿同旦暮，江柳共风烟。已似长沙傅，从今又几年。",
        "title": "新年作",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_423": {
        "content": "红叶晚萧萧，长亭酒一瓢。残云归太华，疏雨过中条。 树色随山迥，河声入海遥。帝乡明日到，犹自梦渔樵。",
        "title": "秋日赴阙题潼关驿楼 / 行次潼关逢魏扶东归",
        "author": "许浑",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_424": {
        "content": "一路经行处，莓苔见履痕。白云依静渚，春草闭闲门。 过雨看松色，随山到水源。溪花与禅意，相对亦忘言。",
        "title": "寻南溪常山道人隐居 / 寻南溪常道士",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_425": {
        "content": "荒戍落黄叶，浩然离故关。高风汉阳渡，初日郢门山。 江上几人在，天涯孤棹还。何当重相见，尊酒慰离颜。",
        "title": "送人东游",
        "author": "温庭筠",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_426": {
        "content": "古台摇落后，秋日望乡心。野寺人来少，云峰水隔深。夕阳依旧垒，寒磬满空林。惆怅南朝事，长江独至今。",
        "title": "秋日登吴公台上寺远眺",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_427": {
        "content": "遥夜泛清瑟，西风生翠萝。残萤栖玉露，早雁拂金河。高树晓还密，远山晴更多。淮南一叶下，自觉洞庭波。",
        "title": "早秋三首·其一",
        "author": "许浑",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_428": {
        "content": "移家虽带郭，野径入桑麻。近种篱边菊，秋来未著花。 扣门无犬吠，欲去问西家。报道山中去，归时每日斜。",
        "title": "寻陆鸿渐不遇",
        "author": "皎然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_429": {
        "content": "望君烟水阔，挥手泪沾巾。飞鸟没何处，青山空向人。长江一帆远，落日五湖春。谁见汀洲上，相思愁白蘋。",
        "title": "饯别王十一南游",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_430": {
        "content": "天地英雄气，千秋尚凛然。势分三足鼎，业复五铢钱。 得相能开国，生儿不象贤。凄凉蜀故妓，来舞魏宫前。",
        "title": "蜀先主庙",
        "author": "刘禹锡",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_431": {
        "content": "故关衰草遍，离别自堪悲。(自堪悲 一作：正堪悲)路出寒云外，人归暮雪时。少孤为客早，多难识君迟。掩泪空相向，风尘何处期。",
        "title": "李端公 / 送李端",
        "author": "卢纶",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_432": {
        "content": "道由白云尽，春与青溪长。时有落花至，远随流水香。 闲门向山路，深柳读书堂。幽映每白日，清辉照衣裳。",
        "title": "阙题",
        "author": "刘昚虚",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_433": {
        "content": "上国随缘住，来途若梦行。浮天沧海远，去世法舟轻。水月通禅寂，鱼龙听梵声。惟怜一灯影，万里眼中明。",
        "title": "送僧归日本",
        "author": "钱起",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_434": {
        "content": "泉壑带茅茨，云霞生薜帷。竹怜新雨后，山爱夕阳时。 闲鹭栖常早，秋花落更迟。家童扫萝径，昨与故人期。",
        "title": "谷口书斋寄杨补阙",
        "author": "钱起",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_435": {
        "content": "流落征南将，曾驱十万师。罢归无旧业，老去恋明时。独立三边静，轻生一剑知。茫茫江汉上，日暮欲何之。",
        "title": "送李中丞之襄州 / 送李中丞归汉阳别业",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_436": {
        "content": "西陆蝉声唱，南冠客思深。(客思深 一作：客思侵)不堪玄鬓影，来对白头吟。(不堪 一作：那堪)露重飞难进，风多响易沉。无人信高洁，谁为表予心？",
        "title": "咏蝉 / 在狱咏蝉",
        "author": "骆宾王",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_437": {
        "content": "昔日戏言身后意，今朝都到眼前来。(身后意 一作：身后事)衣裳已施行看尽，针线犹存未忍开。尚想旧情怜婢仆，也曾因梦送钱财。诚知此恨人人有，贫贱夫妻百事哀。",
        "title": "遣悲怀三首·其二",
        "author": "元稹",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_438": {
        "content": "天秋月又满，城阙夜千重。还作江南会，翻疑梦里逢。 风枝惊暗鹊，露草覆寒蛩。羁旅长堪醉，相留畏晓钟。",
        "title": "客夜与故人偶集 / 江乡故人偶集客舍",
        "author": "戴叔伦",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_439": {
        "content": "闲坐悲君亦自悲，百年多是几多时。邓攸无子寻知命，潘岳悼亡犹费词。同穴窅冥何所望，他生缘会更难期。惟将终夜常开眼，报答平生未展眉。",
        "title": "遣悲怀三首·其三",
        "author": "元稹",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_440": {
        "content": "洞门高阁霭馀辉，桃李阴阴柳絮飞。禁里疏钟官舍晚，省中啼鸟吏人稀。晨摇玉佩趋金殿，夕奉天书拜琐闱。强欲从君无那老，将因卧病解朝衣。",
        "title": "酬郭给事",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_441": {
        "content": "长簟迎风早，空城澹月华。星河秋一雁，砧杵夜千家。 节候看应晚，心期卧亦赊。向来吟秀句，不觉已鸣鸦。",
        "title": "酬程延秋夜即事见赠",
        "author": "韩翃",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_442": {
        "content": "谢公最小偏怜女，自嫁黔娄百事乖。顾我无衣搜荩箧，泥他沽酒拔金钗。(荩箧 一作：画箧)野蔬充膳甘长藿，落叶添薪仰古槐。今日俸钱过十万，与君营奠复营斋。",
        "title": "遣悲怀三首·其一",
        "author": "元稹",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_443": {
        "content": "积雨空林烟火迟，蒸藜炊黍饷东菑。漠漠水田飞白鹭，阴阴夏木啭黄鹂。山中习静观朝槿，松下清斋折露葵。野老与人争席罢，海鸥何事更相疑。",
        "title": "积雨辋川庄作 / 秋归辋川庄作",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_444": {
        "content": "时难年荒世业空，弟兄羁旅各西东。田园寥落干戈后，骨肉流离道路中。吊影分为千里雁，辞根散作九秋蓬。共看明月应垂泪，一夜乡心五处同。",
        "title": "望月有感",
        "author": "白居易",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_445": {
        "content": "鸡鸣紫陌曙光寒，莺啭皇州春色阑。金阙晓钟开万户，玉阶仙仗拥千官。花迎剑珮星初落，柳拂旌旗露未干。独有凤凰池上客，阳春一曲和皆难。",
        "title": "奉和中书舍人贾至早朝大明宫",
        "author": "岑参",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_446": {
        "content": "五夜漏声催晓箭，九重春色醉仙桃。旌旗日暖龙蛇动，宫殿风微燕雀高。朝罢香烟携满袖，诗成珠玉在挥毫。欲知世掌丝纶美，池上于今有凤毛。",
        "title": "奉和贾至舍人早朝大明宫",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_447": {
        "content": "渭水自萦秦塞曲，黄山旧绕汉宫斜。銮舆迥出千门柳，阁道回看上苑花。云里帝城双凤阙，雨中春树万人家。为乘阳气行时令，不是宸游玩物华。",
        "title": "奉和圣制从蓬莱向兴庆阁道中留春雨中春望之作应制",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_448": {
        "content": "凤凰台上凤凰游，凤去台空江自流。吴宫花草埋幽径，晋代衣冠成古丘。三山半落青天外，二水中分白鹭洲。(二水 一作：一水)总为浮云能蔽日，长安不见使人愁。",
        "title": "登金陵凤凰台",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_449": {
        "content": "重帏深下莫愁堂，卧后清宵细细长。神女生涯原是梦，小姑居处本无郎。风波不信菱枝弱，月露谁教桂叶香。直道相思了无益，未妨惆怅是清狂。",
        "title": "无题·重帏深下莫愁堂",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_450": {
        "content": "相见时难别亦难，东风无力百花残。春蚕到死丝方尽，蜡炬成灰泪始干。晓镜但愁云鬓改，夜吟应觉月光寒。蓬山此去无多路，青鸟殷勤为探看。(蓬山 一作：蓬莱)",
        "title": "无题·相见时难别亦难",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_451": {
        "content": "凤尾香罗薄几重，碧文圆顶夜深缝。扇裁月魄羞难掩，车走雷声语未通。曾是寂寥金烬暗，断无消息石榴红。斑骓只系垂杨岸，何处西南任好风。",
        "title": "无题·凤尾香罗薄几重",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_452": {
        "content": "飒飒东风细雨来，芙蓉塘外有轻雷。金蟾啮锁烧香入，玉虎牵丝汲井回。贾氏窥帘韩掾少，宓妃留枕魏王才。春心莫共花争发，一寸相思一寸灰！",
        "title": "无题·飒飒东风细雨来",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_453": {
        "content": "来是空言去绝踪，月斜楼上五更钟。梦为远别啼难唤，书被催成墨未浓。蜡照半笼金翡翠，麝熏微度绣芙蓉。刘郎已恨蓬山远，更隔蓬山一万重！",
        "title": "无题·来是空言去绝踪",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_454": {
        "content": "锦瑟无端五十弦，一弦一柱思华年。庄生晓梦迷蝴蝶，望帝春心托杜鹃。沧海月明珠有泪，蓝田日暖玉生烟。此情可待成追忆，只是当时已惘然。",
        "title": "锦瑟",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_455": {
        "content": "昨夜星辰昨夜风，画楼西畔桂堂东。身无彩凤双飞翼，心有灵犀一点通。隔座送钩春酒暖，分曹射覆蜡灯红。嗟余听鼓应官去，走马兰台类转蓬。",
        "title": "无题·昨夜星辰昨夜风",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_456": {
        "content": "猿鸟犹疑畏简书，风云常为护储胥。徒令上将挥神笔，终见降王走传车。管乐有才原不忝，关张无命欲何如？他年锦里经祠庙，梁父吟成恨有余。",
        "title": "筹笔驿",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_457": {
        "content": "怅卧新春白袷衣，白门寥落意多违。红楼隔雨相望冷，珠箔飘灯独自归。远路应悲春晼晚，残霄犹得梦依稀。玉珰缄札何由达，万里云罗一雁飞。",
        "title": "春雨",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_458": {
        "content": "朝闻游子唱离歌，昨夜微霜初渡河。鸿雁不堪愁里听，云山况是客中过。关城树色催寒近，御苑砧声向晚多。(色 一作：曙)莫见长安行乐处，空令岁月易蹉跎。",
        "title": "送魏万之京",
        "author": "李颀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_459": {
        "content": "群山万壑赴荆门，生长明妃尚有村。一去紫台连朔漠，独留青冢向黄昏。画图省识春风面，环佩空归夜月魂。(夜月 一作：月夜 环 一作：环)千载琵琶作胡语，分明怨恨曲中论。",
        "title": "咏怀古迹五首·其三",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_460": {
        "content": "紫泉宫殿锁烟霞，欲取芜城作帝家。玉玺不缘归日角，锦帆应是到天涯。于今腐草无萤火，终古垂杨有暮鸦。地下若逢陈后主，岂宜重问后庭花。",
        "title": "隋宫",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_461": {
        "content": "蜀主窥吴幸三峡，崩年亦在永安宫。翠华想像空山里，玉殿虚无野寺中。古庙杉松巢水鹤，岁时伏腊走村翁。武侯祠堂常邻近，一体君臣祭祀同。",
        "title": "咏怀古迹五首·其四",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_462": {
        "content": "岁暮阴阳催短景，天涯霜雪霁寒宵。五更鼓角声悲壮，三峡星河影动摇。野哭几家闻战伐，夷歌数处起渔樵。卧龙跃马终黄土，人事依依漫寂寥。(版本一)岁暮阴阳催短景，天涯霜雪霁寒宵。五更鼓角声悲壮，三峡星河影动摇。野哭千家闻战伐，夷歌数处起渔樵。卧龙跃马终黄土，人事音书漫寂寥。(版本二)",
        "title": "阁夜",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_463": {
        "content": "清秋幕府井梧寒，独宿江城蜡炬残。永夜角声悲自语，中天月色好谁看。风尘荏苒音书绝，关塞萧条行路难。已忍伶俜十年事，强移栖息一枝安。",
        "title": "宿府",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_464": {
        "content": "摇落深知宋玉悲，风流儒雅亦吾师。怅望千秋一洒泪，萧条异代不同时。江山故宅空文藻，云雨荒台岂梦思。最是楚宫俱泯灭，舟人指点到今疑。",
        "title": "咏怀古迹五首·其二",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_465": {
        "content": "诸葛大名垂宇宙，宗臣遗像肃清高。三分割据纡筹策，万古云霄一羽毛。伯仲之间见伊吕，指挥若定失萧曹。运移汉祚终难复，志决身歼军务劳。",
        "title": "咏怀古迹五首·其五",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_466": {
        "content": "花近高楼伤客心，万方多难此登临。锦江春色来天地，玉垒浮云变古今。北极朝廷终不改，西山寇盗莫相侵。可怜后主还祠庙，日暮聊为《梁甫吟》。(梁甫 一作：梁父)",
        "title": "登楼",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_467": {
        "content": "剑外忽传收蓟北，初闻涕泪满衣裳。却看妻子愁何在，漫卷诗书喜欲狂。白日放歌须纵酒，青春作伴好还乡。即从巴峡穿巫峡，便下襄阳向洛阳。",
        "title": "闻官军收河南河北",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_468": {
        "content": "西山白雪三城戍，南浦清江万里桥。海内风尘诸弟隔，天涯涕泪一身遥。惟将迟暮供多病，未有涓埃答圣朝。(惟 通：唯)跨马出郊时极目，不堪人事日萧条。",
        "title": "野望",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_469": {
        "content": "支离东北风尘际，漂泊西南天地间。三峡楼台淹日月，五溪衣服共云山。羯胡事主终无赖，词客哀时且未还。庾信平生最萧瑟，暮年诗赋动江关。",
        "title": "咏怀古迹五首·其一",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_470": {
        "content": "城上高楼接大荒，海天愁思正茫茫。惊风乱飐芙蓉水，密雨斜侵薜荔墙。岭树重遮千里目，江流曲似九回肠。共来百越文身地，犹自音书滞一乡。",
        "title": "登柳州城楼寄漳汀封连四州",
        "author": "柳宗元",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_471": {
        "content": "丞相祠堂何处寻，锦官城外柏森森。映阶碧草自春色，隔叶黄鹂空好音。三顾频烦天下计，两朝开济老臣心。(频烦 一作：频频)出师未捷身先死，长使英雄泪满襟。",
        "title": "蜀相",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_472": {
        "content": "舍南舍北皆春水，但见群鸥日日来。花径不曾缘客扫，蓬门今始为君开。盘飧市远无兼味，樽酒家贫只旧醅。肯与邻翁相对饮，隔篱呼取尽馀杯。(馀 通：余)",
        "title": "客至",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_473": {
        "content": "风急天高猿啸哀，渚清沙白鸟飞回。无边落木萧萧下，不尽长江滚滚来。万里悲秋常作客，百年多病独登台。艰难苦恨繁霜鬓，潦倒新停浊酒杯。",
        "title": "登高",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_474": {
        "content": "莺啼燕语报新年，马邑龙堆路几千。家住层城临汉苑，心随明月到胡天。(层城 一作：秦城)机中锦字论长恨，楼上花枝笑独眠。为问元戎窦车骑，何时返旆勒燕然。",
        "title": "春思",
        "author": "皇甫冉",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_475": {
        "content": "去年花里逢君别，今日花开已一年。世事茫茫难自料，春愁黯黯独成眠。身多疾病思田里，邑有流亡愧俸钱。闻道欲来相问讯，西楼望月几回圆。",
        "title": "寄李儋元锡",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_476": {
        "content": "蓬门未识绮罗香，拟托良媒益自伤。谁爱风流高格调，共怜时世俭梳妆。敢将十指夸针巧，不把双眉斗画长。苦恨年年压金线，为他人作嫁衣裳。",
        "title": "贫女",
        "author": "秦韬玉",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_477": {
        "content": "汉文皇帝有高台，此日登临曙色开。三晋云山皆北向，二陵风雨自东来。关门令尹谁能识，河上仙翁去不回。且欲近寻彭泽宰，陶然共醉菊花杯。",
        "title": "九日登望仙台呈刘明府容",
        "author": "崔曙",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_478": {
        "content": "昔人已乘黄鹤去，此地空余黄鹤楼。黄鹤一去不复返，白云千载空悠悠。晴川历历汉阳树，芳草萋萋鹦鹉洲。日暮乡关何处是？烟波江上使人愁。",
        "title": "黄鹤楼 / 登黄鹤楼",
        "author": "崔颢",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_479": {
        "content": "岧峣太华俯咸京，天外三峰削不成。武帝祠前云欲散，仙人掌上雨初晴。河山北枕秦关险，驿路西连汉畤平。借问路傍名利客，无如此处学长生。",
        "title": "行经华阴",
        "author": "崔颢",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_480": {
        "content": "燕台一望客心惊，笳鼓喧喧汉将营。(笳鼓 一作：箫鼓)万里寒光生积雪，三边曙色动危旌。沙场烽火侵胡月，海畔云山拥蓟城。少小虽非投笔吏，论功还欲请长缨。",
        "title": "望蓟门",
        "author": "祖咏",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_481": {
        "content": "澹然空水对斜晖，曲岛苍茫接翠微。波上马嘶看棹去，柳边人歇待船归。数丛沙草群鸥散，万顷江田一鹭飞。谁解乘舟寻范蠡，五湖烟水独忘机。",
        "title": "利州南渡",
        "author": "温庭筠",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_482": {
        "content": "嗟君此别意何如，驻马衔杯问谪居。巫峡啼猿数行泪，衡阳归雁几封书。青枫江上秋帆远，白帝城边古木疏。圣代即今多雨露，暂时分手莫踌躇。",
        "title": "送李少府贬峡中王少府贬长沙",
        "author": "高适",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_483": {
        "content": "王濬楼船下益州，金陵王气黯然收。千寻铁锁沉江底，一片降幡出石头。人世几回伤往事，山形依旧枕寒流。今逢四海为家日，故垒萧萧芦荻秋。",
        "title": "西塞山怀古",
        "author": "刘禹锡",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_484": {
        "content": "苏武魂销汉使前，古祠高树两茫然。云边雁断胡天月，陇上羊归塞草烟。回日楼台非甲帐，去时冠剑是丁年。茂陵不见封侯印，空向秋波哭逝川。",
        "title": "苏武庙",
        "author": "温庭筠",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_485": {
        "content": "三年谪宦此栖迟，万古惟留楚客悲。秋草独寻人去后，寒林空见日斜时。汉文有道恩犹薄，湘水无情吊岂知。寂寂江山摇落处，怜君何事到天涯。",
        "title": "长沙过贾谊宅",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_486": {
        "content": "汀洲无浪复无烟，楚客相思益渺然。汉口夕阳斜渡鸟，洞庭秋水远连天。孤城背岭寒吹角，独树临江夜泊船。(独 一作：“戍”)贾谊上书忧汉室，长沙谪去古今怜。",
        "title": "自夏口至鹦鹉洲夕望岳阳寄源中丞",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_487": {
        "content": "云开远见汉阳城，犹是孤帆一日程。估客昼眠知浪静，舟人夜语觉潮生。三湘愁鬓逢秋色，万里归心对月明。旧业已随征战尽，更堪江上鼓鼙声。",
        "title": "晚次鄂州",
        "author": "卢纶",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_488": {
        "content": "二月黄莺飞上林，春城紫禁晓阴阴。长乐钟声花外尽，龙池柳色雨中深。阳和不散穷途恨，霄汉长怀捧日心。献赋十年犹未遇，羞将白发对华簪。",
        "title": "赠阙下裴舍人",
        "author": "钱起",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_489": {
        "content": "十二楼中尽晓妆，望仙楼上望君王。锁衔金兽连环冷，水滴铜龙昼漏长。云髻罢梳还对镜，罗衣欲换更添香。遥窥正殿帘开处，袍袴宫人扫御床。",
        "title": "宫词",
        "author": "薛逢",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_490": {
        "content": "仙台初见五城楼，风物凄凄宿雨收。山色遥连秦树晚，砧声近报汉宫秋。疏松影落空坛静，细草香闲小洞幽。何用别寻方外去，人间亦自有丹丘。",
        "title": "同题仙游观",
        "author": "韩翃",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_491": {
        "content": "生涯岂料承优诏，世事空知学醉歌。江上月明胡雁过，淮南木落楚山多。寄身且喜沧洲近，顾影无如白发何。今日龙钟人共弃，愧君犹遣慎风波。",
        "title": "江州重别薛六柳八二员外",
        "author": "刘长卿",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_492": {
        "content": "高卧南斋时，开帷月初吐。清辉澹水木，演漾在窗户。冉冉几盈虚，澄澄变今古。美人清江畔，是夜越吟苦。千里共如何，微风吹兰杜。",
        "title": "同从弟销南斋玩月忆山阴崔少府",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_493": {
        "content": "斜阳照墟落，穷巷牛羊归。(斜 一作：光)野老念牧童，倚杖候荆扉。雉雊麦苗秀，蚕眠桑叶稀。田夫荷锄至，相见语依依。即此羡闲逸，怅然吟式微。",
        "title": "渭川田家",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_494": {
        "content": "言入黄花川，每逐清溪水。随山将万转，趣途无百里。声喧乱石中，色静深松里。漾漾泛菱荇，澄澄映葭苇。我心素已闲，清川澹如此。请留磐石上，垂钓将已矣。(磐石 一作：盘石)",
        "title": "青溪 / 过青溪水作",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_495": {
        "content": "圣代无隐者，英灵尽来归。遂令东山客，不得顾采薇。既至金门远，孰云吾道非。江淮度寒食，京洛缝春衣。置酒长安道，同心与我违。行当浮桂棹，未几拂荆扉。远树带行客，孤城当落晖。吾谋适不用，勿谓知音稀。",
        "title": "送綦毋潜落第还乡 / 送别",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_496": {
        "content": "艳色天下重，西施宁久微。朝为越溪女，暮作吴宫妃。贱日岂殊众，贵来方悟稀。邀人傅香粉，不自著罗衣。君宠益娇态，君怜无是非。当时浣纱伴，莫得同车归。持谢邻家子，效颦安可希。",
        "title": "西施咏",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_497": {
        "content": "塔势如涌出，孤高耸天宫。登临出世界，磴道盘虚空。突兀压神州，峥嵘如鬼工。四角碍白日，七层摩苍穹。下窥指高鸟，俯听闻惊风。连山若波涛，奔凑似朝东。(凑 一作：走；似 一作：如)青槐夹驰道，宫馆何玲珑。(馆 一作：观)秋色从西来，苍然满关中。五陵北原上，万古青濛濛。净理了可悟，胜因夙所宗。誓将挂冠去，觉道资无穷。",
        "title": "与高适薛据同登慈恩寺浮图",
        "author": "岑参",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_498": {
        "content": "花间一壶酒，独酌无相亲。举杯邀明月，对影成三人。月既不解饮，影徒随我身。暂伴月将影，行乐须及春。我歌月徘徊，我舞影零乱。醒时同交欢，醉后各分散。(同交欢 一作：相交欢)永结无情游，相期邈云汉。",
        "title": "月下独酌四首·其一",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_499": {
        "content": "燕草如碧丝，秦桑低绿枝。当君怀归日，是妾断肠时。 春风不相识，何事入罗帏。",
        "title": "春思",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_500": {
        "content": "下马饮君酒，问君何所之？君言不得意，归卧南山陲。但去莫复问，白云无尽时。",
        "title": "送别",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_501": {
        "content": "死别已吞声，生别常恻恻。江南瘴疠地，逐客无消息。故人入我梦，明我长相忆。恐非平生魂，路远不可测。魂来枫林青，魂返关塞黑。君今在罗网，何以有羽翼。落月满屋梁，犹疑照颜色。水深波浪阔，无使蛟龙得。(版本一)死别已吞声，生别常恻恻。江南瘴疠地，逐客无消息。故人入我梦，明我长相忆。君今在罗网，何以有羽翼。恐非平生魂，路远不可测。魂来枫林青，魂返关塞黑。落月满屋梁，犹疑照颜色。水深波浪阔，无使蛟龙得。(版本二)",
        "title": "梦李白二首·其一",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_502": {
        "content": "昔岁逢太平，山林二十年。泉源在庭户，洞壑当门前。井税有常期，日晏犹得眠。忽然遭世变，数岁亲戎旃。今来典斯郡，山夷又纷然。城小贼不屠，人贫伤可怜。是以陷邻境，此州独见全。使臣将王命，岂不如贼焉？今彼征敛者，迫之如火煎。谁能绝人命，以作时世贤！思欲委符节，引竿自刺船。将家就鱼麦，归老江湖边。",
        "title": "贼退示官吏",
        "author": "元结",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_503": {
        "content": "浮云终日行，游子久不至。三夜频梦君，情亲见君意。告归常局促，苦道来不易。江湖多风波，舟楫恐失坠。出门搔白首，若负平生志。冠盖满京华，斯人独憔悴。孰云网恢恢，将老身反累。千秋万岁名，寂寞身后事。",
        "title": "梦李白二首·其二",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_504": {
        "content": "岱宗夫如何？齐鲁青未了。造化钟神秀，阴阳割昏晓。荡胸生曾云，决眦入归鸟。( 曾 通：层)会当凌绝顶，一览众山小。",
        "title": "望岳",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_505": {
        "content": "人生不相见，动如参与商。今夕复何夕，共此灯烛光！少壮能几时？鬓发各已苍！访旧半为鬼，惊呼热中肠。焉知二十载，重上君子堂。昔别君未婚，儿女忽成行。怡然敬父执，问我来何方？问答未及已，驱儿罗酒浆。夜雨剪春韭，新炊间黄粱。主称会面难，一举累十觞。十觞亦不醉，感子故意长。明日隔山岳，世事两茫茫。 ",
        "title": "赠卫八处士",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_506": {
        "content": "绝代有佳人，幽居在空谷。自云良家子，零落依草木。关中昔丧乱，兄弟遭杀戮。官高何足论，不得收骨肉。世情恶衰歇，万事随转烛。夫婿轻薄儿，新人美如玉。合昏尚知时，鸳鸯不独宿。但见新人笑，那闻旧人哭。在山泉水清，出山泉水浊。侍婢卖珠回，牵萝补茅屋。摘花不插发，采柏动盈掬。天寒翠袖薄，日暮倚修竹。",
        "title": "佳人",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_507": {
        "content": "暮从碧山下，山月随人归。却顾所来径，苍苍横翠微。相携及田家，童稚开荆扉。绿竹入幽径，青萝拂行衣。欢言得所憩，美酒聊共挥。长歌吟松风，曲尽河星稀。我醉君复乐，陶然共忘机。",
        "title": "下终南山过斛斯山人宿置酒",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_508": {
        "content": "绝顶一茅茨，直上三十里。扣关无僮仆，窥室唯案几。 若非巾柴车，应是钓秋水。差池不相见，黾勉空仰止。 草色新雨中，松声晚窗里。及兹契幽绝，自足荡心耳。 虽无宾主意，颇得清净理。兴尽方下山，何必待之子。",
        "title": "寻西山隐者不遇 / 山行寻隐者不遇",
        "author": "丘为",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_509": {
        "content": "汲井漱寒齿，清心拂尘服。闲持贝叶书，步出东斋读。真源了无取，妄迹世所逐。遗言冀可冥，缮性何由熟。道人庭宇静，苔色连深竹。日出雾露馀，青松如膏沐。澹然离言说，悟悦心自足。",
        "title": "晨诣超师院读禅经",
        "author": "柳宗元",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_510": {
        "content": "北山白云里，隐者自怡悦。相望试登高，心随雁飞灭。(试 一作 始)愁因薄暮起，兴是清秋发。时见归村人，沙行渡头歇。天边树若荠，江畔洲如月。何当载酒来，共醉重阳节。",
        "title": "秋登兰山寄张五 / 秋登万山寄张五 / 九月九日岘山寄张子容 / 秋登万山",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_511": {
        "content": "山光忽西落，池月渐东上。散发乘夕凉，开轩卧闲敞。荷风送香气，竹露滴清响。欲取鸣琴弹，恨无知音赏。感此怀故人，中宵劳梦想。(宵 一作：终)",
        "title": "夏日南亭怀辛大",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_512": {
        "content": "夕阳度西岭，群壑倏已暝。松月生夜凉，风泉满清听。 樵人归欲尽，烟鸟栖初定。之子期宿来，孤琴候萝径。",
        "title": "宿业师山房期丁大不至 / 宿业师山房待丁大不至",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_513": {
        "content": "久为簪组累，幸此南夷谪。闲依农圃邻，偶似山林客。 晓耕翻露草，夜榜响溪石。来往不逢人，长歌楚天碧。",
        "title": "溪居",
        "author": "柳宗元",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_514": {
        "content": "客从东方来，衣上灞陵雨。问客何为来，采山因买斧。 冥冥花正开，飏飏燕新乳。昨别今已春，鬓丝生几缕。",
        "title": "长安遇冯著",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_515": {
        "content": "永日方戚戚，出行复悠悠。女子今有行，大江溯轻舟。尔辈苦无恃，抚念益慈柔。幼为长所育，两别泣不休。对此结中肠，义往难复留。自小阙内训，事姑贻我忧。赖兹托令门，任恤庶无尤。贫俭诚所尚，资从岂待周。孝恭遵妇道，容止顺其猷。别离在今晨，见尔当何秋。居闲始自遣，临感忽难收。归来视幼女，零泪缘缨流。",
        "title": "送杨氏女",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_516": {
        "content": "落帆逗淮镇，停舫临孤驿。浩浩风起波，冥冥日沉夕。 人归山郭暗，雁下芦洲白。独夜忆秦关，听钟未眠客。",
        "title": "夕次盱眙县",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_517": {
        "content": "吏舍跼终年，出郊旷清曙。杨柳散和风，青山澹吾虑。依丛适自憩，缘涧还复去。微雨霭芳原，春鸠鸣何处。乐幽心屡止，遵事迹犹遽。终罢斯结庐，慕陶直可庶。",
        "title": "东郊",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_518": {
        "content": "兵卫森画戟，宴寝凝清香。海上风雨至，逍遥池阁凉。烦疴近消散，嘉宾复满堂。自惭居处崇，未睹斯民康。理会是非遣，性达形迹忘。鲜肥属时禁，蔬果幸见尝。俯饮一杯酒，仰聆金玉章。神欢体自轻，意欲凌风翔。吴中盛文史，群彦今汪洋。方知大藩地，岂曰财赋强。",
        "title": "郡斋雨中与诸文士燕集",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_519": {
        "content": "今朝郡斋冷，忽念山中客。涧底束荆薪，归来煮白石。欲持一瓢酒，远慰风雨夕。落叶满空山，何处寻行迹。",
        "title": "寄全椒山中道士",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_520": {
        "content": "凄凄去亲爱，泛泛入烟雾。归棹洛阳人，残钟广陵树。 今朝此为别，何处还相遇。世事波上舟，沿洄安得住。",
        "title": "初发扬子寄元大校书",
        "author": "韦应物",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_521": {
        "content": "孤鸿海上来，池潢不敢顾。侧见双翠鸟，巢在三珠树。矫矫珍木巅，得无金丸惧？美服患人指，高明逼神恶。今我游冥冥，弋者何所慕！",
        "title": "感遇十二首·其四",
        "author": "张九龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_522": {
        "content": "清溪深不测，隐处唯孤云。松际露微月，清光犹为君。 茅亭宿花影，药院滋苔纹。余亦谢时去，西山鸾鹤群。",
        "title": "宿王昌龄隐居",
        "author": "常建",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_523": {
        "content": "兰叶春葳蕤，桂华秋皎洁。欣欣此生意，自尔为佳节。谁知林栖者，闻风坐相悦。草木有本心，何求美人折！",
        "title": "感遇十二首·其一",
        "author": "张九龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_524": {
        "content": "幽意无断绝，此去随所偶。晚风吹行舟，花路入溪口。际夜转西壑，隔山望南斗。潭烟飞溶溶，林月低向后。生事且弥漫，愿为持竿叟。",
        "title": "春泛若耶溪",
        "author": "綦毋潜",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_525": {
        "content": "江南有丹橘，经冬犹绿林。岂伊地气暖？自有岁寒心。可以荐嘉客，奈何阻重深。运命惟所遇，循环不可寻。徒言树桃李，此木岂无阴？",
        "title": "感遇·江南有丹橘",
        "author": "张九龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_526": {
        "content": "汉皇重色思倾国，御宇多年求不得。杨家有女初长成，养在深闺人未识。天生丽质难自弃，一朝选在君王侧。回眸一笑百媚生，六宫粉黛无颜色。春寒赐浴华清池，温泉水滑洗凝脂。侍儿扶起娇无力，始是新承恩泽时。云鬓花颜金步摇，芙蓉帐暖度春宵。春宵苦短日高起，从此君王不早朝。承欢侍宴无闲暇，春从春游夜专夜。后宫佳丽三千人，三千宠爱在一身。金屋妆成娇侍夜，玉楼宴罢醉和春。姊妹弟兄皆列土，可怜光彩生门户。遂令天下父母心，不重生男重生女。骊宫高处入青云，仙乐风飘处处闻。缓歌慢舞凝丝竹，尽日君王看不足。渔阳鼙鼓动地来，惊破霓裳羽衣曲。九重城阙烟尘生，千乘万骑西南行。翠华摇摇行复止，西出都门百余里。六军不发无奈何，宛转蛾眉马前死。花钿委地无人收，翠翘金雀玉搔头。君王掩面救不得，回看血泪相和流。黄埃散漫风萧索，云栈萦纡登剑阁。峨嵋山下少人行，旌旗无光日色薄。蜀江水碧蜀山青，圣主朝朝暮暮情。行宫见月伤心色，夜雨闻铃肠断声。天旋地转回龙驭，到此踌躇不能去。马嵬坡下泥土中，不见玉颜空死处。君臣相顾尽沾衣，东望都门信马归。归来池苑皆依旧，太液芙蓉未央柳。芙蓉如面柳如眉，对此如何不泪垂。春风桃李花开日，秋雨梧桐叶落时。西宫南内多秋草，落叶满阶红不扫。(花开日 一作：花开夜；南内 一作：南苑)梨园弟子白发新，椒房阿监青娥老。夕殿萤飞思悄然，孤灯挑尽未成眠。迟迟钟鼓初长夜，耿耿星河欲曙天。鸳鸯瓦冷霜华重，翡翠衾寒谁与共。悠悠生死别经年，魂魄不曾来入梦。临邛道士鸿都客，能以精诚致魂魄。为感君王辗转思，遂教方士殷勤觅。排空驭气奔如电，升天入地求之遍。上穷碧落下黄泉，两处茫茫皆不见。忽闻海上有仙山，山在虚无缥渺间。楼阁玲珑五云起，其中绰约多仙子。中有一人字太真，雪肤花貌参差是。金阙西厢叩玉扃，转教小玉报双成。闻道汉家天子使，九华帐里梦魂惊。揽衣推枕起徘徊，珠箔银屏迤逦开。云鬓半偏新睡觉，花冠不整下堂来。风吹仙袂飘飘举，犹似霓裳羽衣舞。玉容寂寞泪阑干，梨花一枝春带雨。(阑 通：栏；飘飘 一作：飘飖)含情凝睇谢君王，一别音容两渺茫。昭阳殿里恩爱绝，蓬莱宫中日月长。回头下望人寰处，不见长安见尘雾。惟将旧物表深情，钿合金钗寄将去。钗留一股合一扇，钗擘黄金合分钿。但教心似金钿坚，天上人间会相见。临别殷勤重寄词，词中有誓两心知。七月七日长生殿，夜半无人私语时。在天愿作比翼鸟，在地愿为连理枝。天长地久有时尽，此恨绵绵无绝期。",
        "title": "长恨歌",
        "author": "白居易",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_527": {
        "content": "幽人归独卧，滞虑洗孤清。持此谢高鸟，因之传远情。日夕怀空意，人谁感至精？飞沈理自隔，何所慰吾诚?",
        "title": "幽人归独卧",
        "author": "张九龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_528": {
        "content": "序：漫叟以公田米酿酒，因休暇，则载酒于湖上，时取一醉。欢醉中，据湖岸，引臂向鱼取酒，使舫载之，偏饮坐者。意疑倚巴丘酌于君山之上，诸子环洞庭而坐，酒舫泛泛然触波涛而往来者。乃作歌以长之。石鱼湖，似洞庭，夏水欲满君山青。山为樽，水为沼，酒徒历历坐洲岛。长风连日作大浪，不能废人运酒舫。我持长瓢坐巴丘，酌饮四坐以散愁。  ",
        "title": "石鱼湖上醉歌",
        "author": "元结",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_529": {
        "content": "浔阳江头夜送客，枫叶荻花秋瑟瑟。主人下马客在船，举酒欲饮无管弦。醉不成欢惨将别，别时茫茫江浸月。忽闻水上琵琶声，主人忘归客不发。寻声暗问弹者谁？琵琶声停欲语迟。移船相近邀相见，添酒回灯重开宴。千呼万唤始出来，犹抱琵琶半遮面。转轴拨弦三两声，未成曲调先有情。弦弦掩抑声声思，似诉平生不得志。（不得志 一作：不得意）低眉信手续续弹，说尽心中无限事。轻拢慢捻抹复挑，初为《霓裳》后《六幺》（六幺 一作：绿腰）。大弦嘈嘈如急雨，小弦切切如私语。嘈嘈切切错杂弹，大珠小珠落玉盘。间关莺语花底滑，幽咽泉流冰下难。冰泉冷涩弦凝绝，凝绝不通声暂歇。(暂歇 一作：渐歇)别有幽愁暗恨生，此时无声胜有声。银瓶乍破水浆迸，铁骑突出刀枪鸣。曲终收拨当心画，四弦一声如裂帛。东船西舫悄无言，唯见江心秋月白。沉吟放拨插弦中，整顿衣裳起敛容。自言本是京城女，家在虾蟆陵下住。十三学得琵琶成，名属教坊第一部。曲罢曾教善才服，妆成每被秋娘妒。五陵年少争缠头，一曲红绡不知数。钿头银篦击节碎，血色罗裙翻酒污。(银篦 一作：云篦)今年欢笑复明年，秋月春风等闲度。弟走从军阿姨死，暮去朝来颜色故。门前冷落鞍马稀，老大嫁作商人妇。商人重利轻别离，前月浮梁买茶去。去来江口守空船，绕船月明江水寒。夜深忽梦少年事，梦啼妆泪红阑干。我闻琵琶已叹息，又闻此语重唧唧。同是天涯沦落人，相逢何必曾相识！我从去年辞帝京，谪居卧病浔阳城。浔阳地僻无音乐，终岁不闻丝竹声。住近湓江地低湿，黄芦苦竹绕宅生。其间旦暮闻何物？杜鹃啼血猿哀鸣。春江花朝秋月夜，往往取酒还独倾。岂无山歌与村笛？呕哑嘲哳难为听。今夜闻君琵琶语，如听仙乐耳暂明。莫辞更坐弹一曲，为君翻作《琵琶行》。感我此言良久立，却坐促弦弦转急。凄凄不似向前声，满座重闻皆掩泣。座中泣下谁最多？江州司马青衫湿。",
        "title": "琵琶行 / 琵琶引",
        "author": "白居易",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_530": {
        "content": "北风卷地白草折，胡天八月即飞雪。忽如一夜春风来，千树万树梨花开。散入珠帘湿罗幕，狐裘不暖锦衾薄。将军角弓不得控，都护铁衣冷难着。(难着 一作：犹著)瀚海阑干百丈冰，愁云惨淡万里凝。中军置酒饮归客，胡琴琵琶与羌笛。纷纷暮雪下辕门，风掣红旗冻不翻。轮台东门送君去，去时雪满天山路。山回路转不见君，雪上空留马行处。",
        "title": "白雪歌送武判官归京",
        "author": "岑参",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_531": {
        "content": "君不见走马川行雪海边，平沙莽莽黄入天。 轮台九月风夜吼，一川碎石大如斗，随风满地石乱走。 匈奴草黄马正肥，金山西见烟尘飞，汉家大将西出师。 将军金甲夜不脱，半夜军行戈相拨，风头如刀面如割。 马毛带雪汗气蒸，五花连钱旋作冰，幕中草檄砚水凝。 虏骑闻之应胆慑，料知短兵不敢接，车师西门伫献捷。",
        "title": "走马川行奉送出师西征 / 走马川行奉送封大夫出师西征",
        "author": "岑参",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_532": {
        "content": "轮台城头夜吹角，轮台城北旄头落。羽书昨夜过渠黎，单于已在金山西。戍楼西望烟尘黑，汉军屯在轮台北。上将拥旄西出征，平明吹笛大军行。四边伐鼓雪海涌，三军大呼阴山动。虏塞兵气连云屯，战场白骨缠草根。剑河风急雪片阔，沙口石冻马蹄脱。(雪片阔 一作：云片阔)亚相勤王甘苦辛，誓将报主静边尘。古来青史谁不见，今见功名胜古人。",
        "title": "轮台歌奉送封大夫出师西征",
        "author": "岑参",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_533": {
        "content": "弃我去者，昨日之日不可留；乱我心者，今日之日多烦忧。长风万里送秋雁，对此可以酣高楼。蓬莱文章建安骨，中间小谢又清发。俱怀逸兴壮思飞，欲上青天览明月。(览 通：揽；明月 一作：日月)抽刀断水水更流，举杯销愁愁更愁。(销愁 一作 消愁）人生在世不称意，明朝散发弄扁舟。",
        "title": "宣州谢脁楼饯别校书叔云 / 陪侍御叔华登楼歌",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_534": {
        "content": "海客谈瀛洲，烟涛微茫信难求；越人语天姥，云霞明灭或可睹。天姥连天向天横，势拔五岳掩赤城。天台四万八千丈，对此欲倒东南倾。(四万 一作：一万)我欲因之梦吴越，一夜飞度镜湖月。(度 通：渡)湖月照我影，送我至剡溪。谢公宿处今尚在，渌水荡漾清猿啼。脚著谢公屐，身登青云梯。半壁见海日，空中闻天鸡。千岩万转路不定，迷花倚石忽已暝。熊咆龙吟殷岩泉，栗深林兮惊层巅。云青青兮欲雨，水澹澹兮生烟。列缺霹雳，丘峦崩摧。洞天石扉，訇然中开。青冥浩荡不见底，日月照耀金银台。 霓为衣兮风为马，云之君兮纷纷而来下。虎鼓瑟兮鸾回车，仙之人兮列如麻。忽魂悸以魄动，恍惊起而长嗟。惟觉时之枕席，失向来之烟霞。世间行乐亦如此，古来万事东流水。别君去兮何时还？且放白鹿青崖间。须行即骑访名山。安能摧眉折腰事权贵，使我不得开心颜!",
        "title": "梦游天姥吟留别 / 别东鲁诸公",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_535": {
        "content": "风吹柳花满店香，吴姬压酒唤客尝。(劝客 一作：唤客)金陵子弟来相送，欲行不行各尽觞。请君试问东流水，别意与之谁短长。",
        "title": "金陵酒肆留别",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_536": {
        "content": "元和天子神武姿，彼何人哉轩与羲。誓将上雪列圣耻，坐法宫中朝四夷。淮西有贼五十载，封狼生貙貙生罴。不据山河据平地，长戈利矛日可麾。帝得圣相相曰度，贼斫不死神扶持。腰悬相印作都统，阴风惨澹天王旗。愬武古通作牙爪，仪曹外郎载笔随。 行军司马智且勇，十四万众犹虎貔。入蔡缚贼献太庙，功无与让恩不訾。帝曰汝度功第一，汝从事愈宜为辞。愈拜稽首蹈且舞，金石刻画臣能为。古者世称大手笔，此事不系于职司。当仁自古有不让，言讫屡颔天子颐。公退斋戒坐小阁，濡染大笔何淋漓。点窜《尧典》《舜典》字，涂改《清庙》《生民》诗。文成破体书在纸，清晨再拜铺丹墀。表曰臣愈昧死上，咏神圣功书之碑。碑高三丈字如斗，负以灵鳌蟠以螭。句奇语重喻者少，谗之天子言其私。长绳百尺拽碑倒，粗砂大石相磨治。公之斯文若元气，先时已入人肝脾。汤盘孔鼎有述作，今无其器存其辞。呜呼圣王及圣相，相与烜赫流淳熙。公之斯文不示后，曷与三五相攀追。愿书万本诵万遍，口角流沫右手胝。传之七十有二代，以为封禅玉检明堂基。",
        "title": "韩碑",
        "author": "李商隐",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_537": {
        "content": "蔡女昔造胡笳声，一弹一十有八拍。胡人落泪沾边草，汉使断肠对归客。古戍苍苍烽火寒，大荒沈沈飞雪白。(沈 通：沉)先拂商弦后角羽，四郊秋叶惊摵摵。董夫子，通神明，深山窃听来妖精。言迟更速皆应手，将往复旋如有情。空山百鸟散还合，万里浮云阴且晴。嘶酸雏雁失群夜，断绝胡儿恋母声。川为静其波，鸟亦罢其鸣。乌孙部落家乡远，逻娑沙尘哀怨生。幽音变调忽飘洒，长风吹林雨堕瓦。迸泉飒飒飞木末，野鹿呦呦走堂下。长安城连东掖垣，凤凰池对青琐门。高才脱略名与利，日夕望君抱琴至。",
        "title": "听董大弹胡笳声兼寄语弄房给事",
        "author": "李颀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_538": {
        "content": "南山截竹为觱篥，此乐本自龟兹出。流传汉地曲转奇， 凉州胡人为我吹。傍邻闻者多叹息，远客思乡皆泪垂。 世人解听不解赏，长飙风中自来往。枯桑老柏寒飕飗， 九雏鸣凤乱啾啾。龙吟虎啸一时发，万籁百泉相与秋。 忽然更作渔阳掺，黄云萧条白日暗。变调如闻杨柳春， 上林繁花照眼新。岁夜高堂列明烛，美酒一杯声一曲。",
        "title": "听安万善吹觱篥歌",
        "author": "李颀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_539": {
        "content": "主人有酒欢今夕，请奏鸣琴广陵客。月照城头乌半飞，霜凄万树风入衣。铜炉华烛烛增辉，初弹渌水后楚妃。一声已动物皆静，四座无言星欲稀。清淮奉使千馀里，敢告云山从此始。",
        "title": "琴歌",
        "author": "李颀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_540": {
        "content": "我本楚狂人，凤歌笑孔丘。手持绿玉杖，朝别黄鹤楼。五岳寻仙不辞远，一生好入名山游。庐山秀出南斗傍，屏风九叠云锦张。影落明湖青黛光，金阙前开二峰长，银河倒挂三石梁。香炉瀑布遥相望，回崖沓嶂凌苍苍。翠影红霞映朝日，鸟飞不到吴天长。登高壮观天地间，大江茫茫去不还。黄云万里动风色，白波九道流雪山。好为庐山谣，兴因庐山发。闲窥石镜清我心，谢公行处苍苔没。早服还丹无世情，琴心三叠道初成。遥见仙人彩云里，手把芙蓉朝玉京。先期汗漫九垓上，愿接卢敖游太清。",
        "title": "庐山谣寄卢侍御虚舟",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_541": {
        "content": "孔明庙前有老柏，柯如青铜根如石。霜皮溜雨四十围，黛色参天二千尺。君臣已与时际会，树木犹为人爱惜。云来气接巫峡长，月出寒通雪山白。忆昨路绕锦亭东，先主武侯同閟宫。崔嵬枝干郊原古，窈窕丹青户牖空。落落盘踞虽得地，冥冥孤高多烈风。扶持自是神明力，正直原因造化工。大厦如倾要梁栋，万牛回首丘山重。不露文章世已惊，未辞翦伐谁能送？苦心岂免容蝼蚁，香叶终经宿鸾凤。志士幽人莫怨嗟：古来材大难为用。",
        "title": "古柏行",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_542": {
        "content": "昔有佳人公孙氏，一舞剑器动四方。观者如山色沮丧，天地为之久低昂。霍如羿射九日落，矫如群帝骖龙翔。来如雷霆收震怒，罢如江海凝清光。绛唇珠袖两寂寞，晚有弟子传芬芳。临颍美人在白帝，妙舞此曲神扬扬。与余问答既有以，感时抚事增惋伤。先帝侍女八千人，公孙剑器初第一。五十年间似反掌，风尘倾动昏王室。梨园弟子散如烟，女乐余姿映寒日。金粟堆前木已拱，瞿唐石城草萧瑟。玳筵急管曲复终，乐极哀来月东出。老夫不知其所往，足茧荒山转愁疾。",
        "title": "观公孙大娘弟子舞剑器行",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_543": {
        "content": "四月南风大麦黄，枣花未落桐叶长。青山朝别暮还见，嘶马出门思旧乡。陈侯立身何坦荡，虬须虎眉仍大颡。腹中贮书一万卷，不肯低头在草莽。东门酤酒饮我曹，心轻万事如鸿毛。醉卧不知白日暮，有时空望孤云高。长河浪头连天黑，津口停舟渡不得。郑国游人未及家，洛阳行子空叹息。闻道故林相识多，罢官昨日今如何。",
        "title": "送陈章甫",
        "author": "李颀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_544": {
        "content": "将军魏武之子孙，于今为庶为清门。英雄割据虽已矣，文采风流今尚存。学书初学卫夫人，但恨无过王右军。丹青不知老将至，富贵于我如浮云。开元之中常引见，承恩数上南薰殿。凌烟功臣少颜色，将军下笔开生面。良相头上进贤冠，猛将腰间大羽箭。褒公鄂公毛发动，英姿飒爽来酣战。先帝御马五花骢，画工如山貌不同。是日牵来赤墀下，迥立阊阖生长风。诏谓将军拂绢素，意匠惨澹经营中。斯须九重真龙出，一洗万古凡马空。玉花却在御榻上，榻上庭前屹相向。至尊含笑催赐金，圉人太仆皆惆怅。弟子韩干早入室，亦能画马穷殊相。干惟画肉不画骨，忍使骅骝气凋丧。将军画善盖有神，必逢佳士亦写真。即今漂泊干戈际，屡貌寻常行路人。途穷反遭俗眼白，世上未有如公贫。但看古来盛名下，终日坎壈缠其身。",
        "title": "丹青引赠曹将军霸 / 丹青引赠曹霸将军",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_545": {
        "content": "男儿事长征，少小幽燕客。赌胜马蹄下，由来轻七尺。杀人莫敢前，须如猬毛磔。黄云陇底白云飞，未得报恩不能归。辽东小妇年十五，惯弹琵琶解歌舞。今为羌笛出塞声，使我三军泪如雨。",
        "title": "古意",
        "author": "李颀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_546": {
        "content": "今我不乐思岳阳，身欲奋飞病在床。美人娟娟隔秋水，濯足洞庭望八荒。鸿飞冥冥日月白，青枫叶赤天雨霜。玉京群帝集北斗，或骑麒麟翳凤凰。芙蓉旌旗烟雾落，影动倒景摇潇湘。星宫之君醉琼浆，羽人稀少不在旁。似闻昨者赤松子，恐是汉代韩张良。昔随刘氏定长安，帷幄未改神惨伤。国家成败吾岂敢，色难腥腐餐枫香。周南留滞古所惜，南极老人应寿昌。美人胡为隔秋水，焉得置之贡玉堂。",
        "title": "寄韩谏议 / 寄韩谏议注",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_547": {
        "content": "国初已来画鞍马，神妙独数江都王。将军得名三十载，人间又见真乘黄。曾貌先帝照夜白，龙池十日飞霹雳。内府殷红玛瑙盘，婕妤传诏才人索。盘赐将军拜舞归，轻纨细绮相追飞。贵戚权门得笔迹，始觉屏障生光辉。昔日太宗拳毛騧，近时郭家狮子花。今之新图有二马，复令识者久叹嗟。此皆骑战一敌万，缟素漠漠开风沙。其余七匹亦殊绝，迥若寒空动烟雪。霜蹄蹴踏长楸间，马官厮养森成列。可怜九马争神骏，顾视清高气深稳。借问苦心爱者谁，后有韦讽前支遁。忆昔巡幸新丰宫，翠华拂天来向东。腾骧磊落三万匹，皆与此图筋骨同。自从献宝朝河宗，无复射蛟江水中。君不见金粟堆前松柏里，龙媒去尽鸟呼风。",
        "title": "韦讽录事宅观曹将军画马图",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_548": {
        "content": "山寺钟鸣昼已昏，渔梁渡头争渡喧。人随沙岸向江村，余亦乘舟归鹿门。鹿门月照开烟树，忽到庞公栖隐处。岩扉松径长寂寥，惟有幽人自来去。",
        "title": "夜归鹿门山歌 / 夜归鹿门歌",
        "author": "孟浩然",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_549": {
        "content": "渔翁夜傍西岩宿，晓汲清湘燃楚竹。烟销日出不见人，欸乃一声山水绿。回看天际下中流，岩上无心云相逐。",
        "title": "渔翁",
        "author": "柳宗元",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_550": {
        "content": "前不见古人，后不见来者。念天地之悠悠，独怆然而涕下。",
        "title": "登幽州台歌",
        "author": "陈子昂",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_551": {
        "content": "张生手持石鼓文，劝我试作石鼓歌。少陵无人谪仙死，才薄将奈石鼓何。周纲凌迟四海沸，宣王愤起挥天戈。大开明堂受朝贺，诸侯剑佩鸣相磨。蒐于岐阳骋雄俊，万里禽兽皆遮罗。镌功勒成告万世，凿石作鼓隳嵯峨。从臣才艺咸第一，拣选撰刻留山阿。雨淋日灸野火燎，鬼物守护烦撝呵。公从何处得纸本，毫发尽备无差讹。辞严义密读难晓，字体不类隶与蝌。年深岂免有缺画，快剑斫断生蛟鼍。鸾翔凤翥众仙下，珊瑚碧树交枝柯。金绳铁索锁钮壮，古鼎跃水龙腾梭。陋儒编诗不收入，二雅褊迫无委蛇。孔子西行不到秦，掎摭星宿遗羲娥。嗟余好古生苦晚，对此涕泪双滂沱。忆昔初蒙博士征，其年始改称元和。故人从军在右辅，为我度量掘臼科。濯冠沐浴告祭酒，如此至宝存岂多。毡包席裹可立致，十鼓只载数骆驼。荐诸太庙比郜鼎，光价岂止百倍过。圣恩若许留太学，诸生讲解得切磋。观经鸿都尚填咽，坐见举国来奔波。剜苔剔藓露节角，安置妥帖平不颇。大厦深檐与盖覆，经历久远期无佗。中朝大官老于事，讵肯感激徒媕娿。牧童敲火牛砺角，谁复著手为摩挲。日销月铄就埋没，六年西顾空吟哦。羲之俗书趁姿媚，数纸尚可博白鹅。继周八代争战罢，无人收拾理则那。方今太平日无事，柄任儒术崇丘轲。安能以此尚论列，愿借辩口如悬河。石鼓之歌止于此，呜呼吾意其蹉跎。",
        "title": "石鼓歌",
        "author": "韩愈",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_552": {
        "content": "山石荦确行径微，黄昏到寺蝙蝠飞。升堂坐阶新雨足，芭蕉叶大栀子肥。僧言古壁佛画好，以火来照所见稀。铺床拂席置羹饭，疏粝亦足饱我饥。夜深静卧百虫绝，清月出岭光入扉。天明独去无道路，出入高下穷烟霏。山红涧碧纷烂漫，时见松枥皆十围。当流赤足踏涧石，水声激激风吹衣。人生如此自可乐，岂必局束为人鞿？(鞿 一作：靰)嗟哉吾党二三子，安得至老不更归。",
        "title": "山石",
        "author": "韩愈",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_553": {
        "content": "五岳祭秩皆三公，四方环镇嵩当中。火维地荒足妖怪，天假神柄专其雄。喷云泄雾藏半腹，虽有绝顶谁能穷？我来正逢秋雨节，阴气晦昧无清风。潜心默祷若有应，岂非正直能感通！须臾静扫众峰出，仰见突兀撑青空。紫盖连延接天柱，石廪腾掷堆祝融。森然魄动下马拜，松柏一径趋灵宫。粉墙丹柱动光彩，鬼物图画填青红。升阶伛偻荐脯酒，欲以菲薄明其衷。庙令老人识神意，睢盱侦伺能鞠躬。手持杯珓导我掷，云此最吉余难同。窜逐蛮荒幸不死，衣食才足甘长终。侯王将相望久绝，神纵欲福难为功。夜投佛寺上高阁，星月掩映云曈昽。猿鸣钟动不知曙，杲杲寒日生于东。",
        "title": "谒衡岳庙遂宿岳寺题门楼",
        "author": "韩愈",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_554": {
        "content": "纤云四卷天无河，清风吹空月舒波。沙平水息声影绝，一杯相属君当歌。君歌声酸辞且苦，不能听终泪如雨。洞庭连天九疑高，蛟龙出没猩鼯号。十生九死到官所，幽居默默如藏逃。下床畏蛇食畏药，海气湿蛰熏腥臊。昨者州前捶大鼓，嗣皇继圣登夔皋。赦书一日行万里，罪从大辟皆除死。迁者追回流者还，涤瑕荡垢清朝班。州家申名使家抑，坎轲只得移荆蛮。判司卑官不堪说，未免捶楚尘埃间。同时辈流多上道，天路幽险难追攀。君歌且休听我歌，我歌今与君殊科。一年明月今宵多，人生由命非由他。有酒不饮奈明何。",
        "title": "八月十五夜赠张功曹",
        "author": "韩愈",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_555": {
        "content": "黄河远上白云间，一片孤城万仞山。羌笛何须怨杨柳，春风不度玉门关。",
        "title": "凉州词二首·其一",
        "author": "王之涣",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_556": {
        "content": "秦时明月汉时关，万里长征人未还。但使龙城飞将在，不教胡马度阴山。",
        "title": "出塞二首·其一",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_557": {
        "content": "蝉鸣空桑林，八月萧关道。出塞入塞寒，处处黄芦草。从来幽并客，皆共沙尘老。莫学游侠儿，矜夸紫骝好。",
        "title": "塞上曲·其一",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_558": {
        "content": "饮马渡秋水，水寒风似刀。平沙日未没，黯黯见临洮。昔日长城战，咸言意气高。黄尘足今古，白骨乱蓬蒿。",
        "title": "塞下曲",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_559": {
        "content": "渭城朝雨浥轻尘，客舍青青柳色新。(一作：客舍依依杨柳春)劝君更尽一杯酒，西出阳关无故人。",
        "title": "渭城曲 / 送元二使安西",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_560": {
        "content": "桂魄初生秋露微，轻罗已薄未更衣。银筝夜久殷勤弄，心怯空房不忍归。",
        "title": "秋夜曲",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_561": {
        "content": "少年十五二十时，步行夺得胡马骑。射杀中山白额虎，肯数邺下黄须儿！一身转战三千里，一剑曾当百万师。汉兵奋迅如霹雳，虏骑崩腾畏蒺藜。卫青不败由天幸，李广无功缘数奇。自从弃置便衰朽，世事蹉跎成白首。昔时飞箭无全目，今日垂杨生左肘。路旁时卖故侯瓜，门前学种先生柳。苍茫古木连穷巷，寥落寒山对虚牖。誓令疏勒出飞泉，不似颍川空使酒。贺兰山下阵如云，羽檄交驰日夕闻。节使三河募年少，诏书五道出将军。试拂铁衣如雪色，聊持宝剑动星文。愿得燕弓射大将，耻令越甲鸣吾军。莫嫌旧日云中守，犹堪一战取功勋。",
        "title": "老将行",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_562": {
        "content": "洛阳女儿对门居，才可颜容十五余。良人玉勒乘骢马，侍女金盘脍鲤鱼。画阁朱楼尽相望，红桃绿柳垂檐向。罗帷送上七香车，宝扇迎归九华帐。狂夫富贵在青春，意气骄奢剧季伦。自怜碧玉亲教舞，不惜珊瑚持与人。春窗曙灭九微火，九微片片飞花琐。戏罢曾无理曲时，妆成祗是熏香坐。城中相识尽繁华，日夜经过赵李家。谁怜越女颜如玉，贫贱江头自浣纱。",
        "title": "洛阳女儿行",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_563": {
        "content": "金井梧桐秋叶黄，珠帘不卷夜来霜。熏笼玉枕无颜色，卧听南宫清漏长。高殿秋砧响夜阑，霜深犹忆御衣寒。银灯青琐裁缝歇，还向金城明主看。奉帚平明金殿开，暂将团扇共徘徊。玉颜不及寒鸦色，犹带昭阳日影来。真成薄命久寻思，梦见君王觉后疑。火照西宫知夜饮，分明复道奉恩时。长信宫中秋月明，昭阳殿下捣衣声。白露堂中细草迹，红罗帐里不胜情。",
        "title": "长信怨",
        "author": "王昌龄",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_564": {
        "content": "渔舟逐水爱山春，两岸桃花夹古津。坐看红树不知远，行尽青溪不见人。山口潜行始隈隩，山开旷望旋平陆。遥看一处攒云树，近入千家散花竹。樵客初传汉姓名，居人未改秦衣服。居人共住武陵源，还从物外起田园。月明松下房栊静，日出云中鸡犬喧。惊闻俗客争来集，竞引还家问都邑。平明闾巷扫花开，薄暮渔樵乘水入。初因避地去人间，及至成仙遂不还。峡里谁知有人事，世中遥望空云山。不疑灵境难闻见，尘心未尽思乡县。出洞无论隔山水，辞家终拟长游衍。自谓经过旧不迷，安知峰壑今来变。当时只记入山深，青溪几度到云林。春来遍是桃花水，不辨仙源何处寻。",
        "title": "桃源行",
        "author": "王维",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_565": {
        "content": "名花倾国两相欢，常得君王带笑看。解释春风无限恨，沉香亭北倚栏杆。 ",
        "title": "清平调·名花倾国两相欢",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_566": {
        "content": "金樽清酒斗十千，玉盘珍羞直万钱。(羞 通：馐；直 通：值)停杯投箸不能食，拔剑四顾心茫然。欲渡黄河冰塞川，将登太行雪满山。(雪满山 一作：雪暗天)闲来垂钓碧溪上，忽复乘舟梦日边。(碧 一作：坐)行路难！行路难！多歧路，今安在？长风破浪会有时，直挂云帆济沧海。",
        "title": "行路难·其一",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_567": {
        "content": "大道如青天，我独不得出。羞逐长安社中儿，赤鸡白雉赌梨粟。弹剑作歌奏苦声，曳裾王门不称情。淮阴市井笑韩信，汉朝公卿忌贾生。君不见昔时燕家重郭隗，拥篲折节无嫌猜。剧辛乐毅感恩分，输肝剖胆效英才。昭王白骨萦蔓草，谁人更扫黄金台？行路难，归去来！",
        "title": "行路难·其二",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_568": {
        "content": "云想衣裳花想容，春风拂槛露华浓。 若非群玉山头见，会向瑶台月下逢。",
        "title": "清平调·其一",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_569": {
        "content": "一枝红艳露凝香，云雨巫山枉断肠。借问汉宫谁得似，可怜飞燕倚新妆。",
        "title": "清平调·其二",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_570": {
        "content": "君不见，黄河之水天上来，奔流到海不复回。君不见，高堂明镜悲白发，朝如青丝暮成雪。人生得意须尽欢，莫使金樽空对月。天生我材必有用，千金散尽还复来。烹羊宰牛且为乐，会须一饮三百杯。岑夫子，丹丘生，将进酒，杯莫停。与君歌一曲，请君为我倾耳听。(倾耳听 一作：侧耳听)钟鼓馔玉不足贵，但愿长醉不复醒。(不足贵 一作：何足贵；不复醒 一作：不愿醒/不用醒)古来圣贤皆寂寞，惟有饮者留其名。(古来 一作：自古；惟 通：唯)陈王昔时宴平乐，斗酒十千恣欢谑。主人何为言少钱，径须沽取对君酌。五花马，千金裘，呼儿将出换美酒，与尔同销万古愁。",
        "title": "将进酒",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_571": {
        "content": "玉阶生白露，夜久侵罗袜。却下水晶帘，玲珑望秋月。(水晶 一作 水精) ",
        "title": "玉阶怨",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_572": {
        "content": "长相思，在长安。络纬秋啼金井阑，微霜凄凄簟色寒。孤灯不明思欲绝，卷帷望月空长叹。美人如花隔云端！上有青冥之长天，下有渌水之波澜。天长路远魂飞苦，梦魂不到关山难。长相思，摧心肝！",
        "title": "长相思·其一",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_573": {
        "content": "有耳莫洗颍川水，有口莫食首阳蕨。含光混世贵无名，何用孤高比云月？吾观自古贤达人，功成不退皆殒身。子胥既弃吴江上，屈原终投湘水滨。陆机雄才岂自保？李斯税驾苦不早。华亭鹤唳讵可闻？上蔡苍鹰何足道？君不见吴中张翰称达生，秋风忽忆江东行。且乐生前一杯酒，何须身后千载名？",
        "title": "行路难·其三",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_574": {
        "content": "日色欲尽花含烟，月明欲素愁不眠。赵瑟初停凤凰柱，蜀琴欲奏鸳鸯弦。此曲有意无人传，愿随春风寄燕然。忆君迢迢隔青天，昔日横波目，今作流泪泉。不信妾断肠，归来看取明镜前。(断肠 一作：肠断)",
        "title": "长相思·其二",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_575": {
        "content": "妾发初覆额，折花门前剧。郎骑竹马来，绕床弄青梅。同居长干里，两小无嫌猜，十四为君妇，羞颜未尝开。低头向暗壁，千唤不一回。十五始展眉，愿同尘与灰。常存抱柱信，岂上望夫台。十六君远行，瞿塘滟滪堆。五月不可触，猿声天上哀。(猿 一作：鸣)门前迟行迹，一一生绿苔。苔深不能扫，落叶秋风早。八月蝴蝶黄，双飞西园草。感此伤妾心，坐愁红颜老。早晚下三巴，预将书报家。相迎不道远，直至长风沙。",
        "title": "长干行·其一",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_576": {
        "content": "噫吁嚱，危乎高哉！蜀道之难，难于上青天！蚕丛及鱼凫，开国何茫然！尔来四万八千岁，不与秦塞通人烟。西当太白有鸟道，可以横绝峨眉巅。地崩山摧壮士死，然后天梯石栈相钩连。上有六龙回日之高标，下有冲波逆折之回川。黄鹤之飞尚不得过，猿猱欲度愁攀援。(攀援 一作：攀缘)青泥何盘盘，百步九折萦岩峦。扪参历井仰胁息，以手抚膺坐长叹。问君西游何时还？畏途巉岩不可攀。但见悲鸟号古木，雄飞雌从绕林间。又闻子规啼夜月，愁空山。蜀道之难,难于上青天，使人听此凋朱颜！连峰去天不盈尺，枯松倒挂倚绝壁。飞湍瀑流争喧豗，砯崖转石万壑雷。其险也如此，嗟尔远道之人胡为乎来哉！(也若此 一作：也如此)剑阁峥嵘而崔嵬，一夫当关，万夫莫开。所守或匪亲，化为狼与豺。朝避猛虎，夕避长蛇；磨牙吮血，杀人如麻。锦城虽云乐，不如早还家。蜀道之难,难于上青天，侧身西望长咨嗟！",
        "title": "蜀道难",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_577": {
        "content": "镜湖三百里，菡萏发荷花。五月西施采，人看隘若耶。回舟不待月，归去越王家。",
        "title": "子夜吴歌·夏歌",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_578": {
        "content": "长安一片月，万户捣衣声。秋风吹不尽，总是玉关情。何日平胡虏，良人罢远征。",
        "title": "子夜吴歌·秋歌",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_579": {
        "content": "秦地罗敷女，采桑绿水边。素手青条上，红妆白日鲜。蚕饥妾欲去，五马莫留连。",
        "title": "子夜吴歌·春歌",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_580": {
        "content": "明朝驿使发，一夜絮征袍。素手抽针冷，那堪把剪刀。裁缝寄远道，几日到临洮。",
        "title": "子夜吴歌·冬歌",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_581": {
        "content": "明月出天山，苍茫云海间。长风几万里，吹度玉门关。汉下白登道，胡窥青海湾。由来征战地，不见有人还。戍客望边邑，思归多苦颜。(望边邑 一作：望边色)高楼当此夜，叹息未应闲。",
        "title": "关山月",
        "author": "李白",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_582": {
        "content": "嫁得瞿塘贾，朝朝误妾期。早知潮有信，嫁与弄潮儿。",
        "title": "江南曲",
        "author": "李益",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_583": {
        "content": "车辚辚，马萧萧，行人弓箭各在腰。耶娘妻子走相送，尘埃不见咸阳桥。(娘 一作：“爷”)牵衣顿足拦道哭，哭声直上干云霄。道旁过者问行人，行人但云点行频。或从十五北防河，便至四十西营田。去时里正与裹头，归来头白还戍边。边庭流血成海水，武皇开边意未已。君不闻汉家山东二百州，千村万落生荆杞。纵有健妇把锄犁，禾生陇亩无东西。况复秦兵耐苦战，被驱不异犬与鸡。长者虽有问，役夫敢申恨？且如今年冬，未休关西卒。县官急索租，租税从何出？信知生男恶，反是生女好。生女犹得嫁比邻，生男埋没随百草。君不见，青海头，古来白骨无人收。新鬼烦冤旧鬼哭，天阴雨湿声啾啾！",
        "title": "兵车行",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_584": {
        "content": "白日登山望烽火，黄昏饮马傍交河。行人刁斗风沙暗，公主琵琶幽怨多。野云万里无城郭，雨雪纷纷连大漠。胡雁哀鸣夜夜飞，胡儿眼泪双双落。闻道玉门犹被遮，应将性命逐轻车。年年战骨埋荒外，空见蒲桃入汉家。",
        "title": "古从军行",
        "author": "李颀",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_585": {
        "content": "长安城头头白乌，夜飞延秋门上呼。又向人家啄大屋，屋底达官走避胡。金鞭断折九马死，骨肉不得同驰驱。腰下宝玦青珊瑚，可怜王孙泣路隅。问之不肯道姓名，但道困苦乞为奴。已经百日窜荆棘，身上无有完肌肤。高帝子孙尽隆准，龙种自与常人殊。豺狼在邑龙在野，王孙善保千金躯。不敢长语临交衢，且为王孙立斯须。昨夜东风吹血腥，东来橐驼满旧都。朔方健儿好身手，昔何勇锐今何愚。窃闻天子已传位，圣德北服南单于。花门剺面请雪耻，慎勿出口他人狙。哀哉王孙慎勿疏，五陵佳气无时无。",
        "title": "哀王孙",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_586": {
        "content": "三月三日天气新，长安水边多丽人。态浓意远淑且真，肌理细腻骨肉匀。绣罗衣裳照暮春，蹙金孔雀银麒麟。头上何所有？翠微盍叶垂鬓唇。背后何所见？珠压腰衱稳称身。就中云幕椒房亲，赐名大国虢与秦。紫驼之峰出翠釜，水精之盘行素鳞。犀箸厌饫久未下，鸾刀缕切空纷纶。黄门飞鞚不动尘，御厨络绎送八珍。箫鼓哀吟感鬼神，宾从杂遝实要津。后来鞍马何逡巡，当轩下马入锦茵。杨花雪落覆白苹，青鸟飞去衔红巾。炙手可热势绝伦，慎莫近前丞相嗔！",
        "title": "丽人行",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_587": {
        "content": "少陵野老吞声哭，春日潜行曲江曲。江头宫殿锁千门，细柳新蒲为谁绿？忆昔霓旌下南苑，苑中万物生颜色。昭阳殿里第一人，同辇随君侍君侧。辇前才人带弓箭，白马嚼啮黄金勒。翻身向天仰射云，一笑正坠双飞翼。明眸皓齿今何在？血污游魂归不得。清渭东流剑阁深，去住彼此无消息。人生有情泪沾臆，江水江花岂终极！黄昏胡骑尘满城，欲往城南望城北。",
        "title": "哀江头",
        "author": "杜甫",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_588": {
        "content": "劝君莫惜金缕衣，劝君惜取少年时。(惜取 一作：须取)花开堪折直须折，莫待无花空折枝。(花开 一作：有花)",
        "title": "金缕衣",
        "author": null,
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_589": {
        "content": "慈母手中线，游子身上衣。临行密密缝，意恐迟迟归。谁言寸草心，报得三春晖。",
        "title": "游子吟",
        "author": "孟郊",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_590": {
        "content": "梧桐相待老，鸳鸯会双死。贞女贵徇夫，舍生亦如此。波澜誓不起，妾心古井水。(古井水 一作：井中水)",
        "title": "列女操 / 烈女操",
        "author": "孟郊",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_591": {
        "content": "汉家烟尘在东北，汉将辞家破残贼。男儿本自重横行，天子非常赐颜色。摐金伐鼓下榆关，旌旗逶迤碣石间。校尉羽书飞瀚海，单于猎火照狼山。山川萧条极边土，胡骑凭陵杂风雨。战士军前半死生，美人帐下犹歌舞。大漠穷秋塞草腓，孤城落日斗兵稀。身当恩遇常轻敌，力尽关山未解围。(常轻敌 一作：恒轻敌)铁衣远戍辛勤久，玉箸应啼别离后。少妇城南欲断肠，征人蓟北空回首。边庭飘飖那可度，绝域苍茫更何有。(飘飖 一作：飘飘)杀气三时作阵云，寒声一夜传刁斗。相看白刃血纷纷，死节从来岂顾勋。君不见沙场征战苦，至今犹忆李将军。",
        "title": "燕歌行",
        "author": "高适",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_592": {
        "content": "鹫翎金仆姑，燕尾绣蝥弧。独立扬新令，千营共一呼。",
        "title": "和张仆射塞下曲·其一",
        "author": "卢纶",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_593": {
        "content": "卢家少妇郁金堂，海燕双栖玳瑁梁。九月寒砧催木叶，十年征戍忆辽阳。白狼河北音书断，丹凤城南秋夜长。谁谓含愁独不见，更教明月照流黄。",
        "title": "古意呈补阙乔知之 / 古意 / 独不见",
        "author": "沈佺期",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_594": {
        "content": "家临九江水，来去九江侧。同是长干人，生小不相识。",
        "title": "长干行·家临九江水",
        "author": "崔颢",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_595": {
        "content": "林暗草惊风，将军夜引弓。平明寻白羽，没在石棱中。",
        "title": "和张仆射塞下曲·其二",
        "author": "卢纶",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_596": {
        "content": "月黑雁飞高，单于夜遁逃。欲将轻骑逐，大雪满弓刀。",
        "title": "和张仆射塞下曲·其三",
        "author": "卢纶",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_597": {
        "content": "野幕敞琼筵，羌戎贺劳旋。醉和金甲舞，雷鼓动山川。",
        "title": "和张仆射塞下曲·其四",
        "author": "卢纶",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    },
    "poem_598": {
        "content": "君家何处住，妾住在横塘。停船暂借问，或恐是同乡。",
        "title": "长干行·君家何处住",
        "author": "崔颢",
        "book": "唐诗三百首",
        "dynasty": "唐代"
    }
}